var items = {
  "block.minecraft.acacia_button": "Acacia knop",
  "block.minecraft.acacia_door": "Acacia deur",
  "block.minecraft.acacia_fence": "Acaciahouten hek",
  "block.minecraft.acacia_fence_gate": "Acaciahouten poort",
  "block.minecraft.acacia_hanging_sign": "Acaciahouten hangbord",
  "block.minecraft.acacia_leaves": "Acaciabladeren",
  "block.minecraft.acacia_log": "Acaciastam",
  "block.minecraft.acacia_planks": "Acacia planken",
  "block.minecraft.acacia_pressure_plate": "Acacia drukplaat",
  "block.minecraft.acacia_sapling": "Acaciakiemplant",
  "block.minecraft.acacia_shelf": "Acaciahouten plank",
  "block.minecraft.acacia_sign": "Acacia bord",
  "block.minecraft.acacia_slab": "Acacia plaat",
  "block.minecraft.acacia_stairs": "Acacia trap",
  "block.minecraft.acacia_trapdoor": "Acacia valluik",
  "block.minecraft.acacia_wall_hanging_sign": "Acaciahouten uithangbord",
  "block.minecraft.acacia_wall_sign": "Acacia bord aan muur",
  "block.minecraft.acacia_wood": "Acaciahout",
  "block.minecraft.activator_rail": "Activatiespoor",
  "block.minecraft.air": "Lucht",
  "block.minecraft.allium": "Look",
  "block.minecraft.amethyst_block": "Amethistblok",
  "block.minecraft.amethyst_cluster": "Amethistcluster",
  "block.minecraft.ancient_debris": "Oud puin",
  "block.minecraft.andesite": "Andesiet",
  "block.minecraft.andesite_slab": "Andesietplaat",
  "block.minecraft.andesite_stairs": "Andesiettrap",
  "block.minecraft.andesite_wall": "Andesietenmuur",
  "block.minecraft.anvil": "Aanvil",
  "block.minecraft.attached_melon_stem": "Aangegroeide meloenstam",
  "block.minecraft.attached_pumpkin_stem": "Aangegroeide pompoenstam",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azaleabladeren",
  "block.minecraft.azure_bluet": "Porseleinsterretje",
  "block.minecraft.bamboo": "Bamboe",
  "block.minecraft.bamboo_block": "Bamboeblok",
  "block.minecraft.bamboo_button": "Bamboeknop",
  "block.minecraft.bamboo_door": "Bamboedeur",
  "block.minecraft.bamboo_fence": "Bamboehek",
  "block.minecraft.bamboo_fence_gate": "Bamboepoort",
  "block.minecraft.bamboo_hanging_sign": "Bamboehangbord",
  "block.minecraft.bamboo_mosaic": "Bamboemozaïek",
  "block.minecraft.bamboo_mosaic_slab": "Bamboemozaïekplaat",
  "block.minecraft.bamboo_mosaic_stairs": "Bamboemozaïektrap",
  "block.minecraft.bamboo_planks": "Bamboeplanken",
  "block.minecraft.bamboo_pressure_plate": "Bamboedrukplaat",
  "block.minecraft.bamboo_sapling": "Bamboescheut",
  "block.minecraft.bamboo_shelf": "Bamboeplank",
  "block.minecraft.bamboo_sign": "Bamboebord",
  "block.minecraft.bamboo_slab": "Bamboeplaat",
  "block.minecraft.bamboo_stairs": "Bamboetrap",
  "block.minecraft.bamboo_trapdoor": "Bamboevalluik",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboe-uithangbord",
  "block.minecraft.bamboo_wall_sign": "Bamboebord aan muur",
  "block.minecraft.banner.base.black": "Zwart vlak",
  "block.minecraft.banner.base.blue": "Blauw vlak",
  "block.minecraft.banner.base.brown": "Bruin vlak",
  "block.minecraft.banner.base.cyan": "Turquoise vlak",
  "block.minecraft.banner.base.gray": "Grijs vlak",
  "block.minecraft.banner.base.green": "Groen vlak",
  "block.minecraft.banner.base.light_blue": "Lichtblauw vlak",
  "block.minecraft.banner.base.light_gray": "Lichtgrijs vlak",
  "block.minecraft.banner.base.lime": "Limoengroen vlak",
  "block.minecraft.banner.base.magenta": "Magenta vlak",
  "block.minecraft.banner.base.orange": "Oranje vlak",
  "block.minecraft.banner.base.pink": "Roze vlak",
  "block.minecraft.banner.base.purple": "Paars vlak",
  "block.minecraft.banner.base.red": "Rood vlak",
  "block.minecraft.banner.base.white": "Wit vlak",
  "block.minecraft.banner.base.yellow": "Geel vlak",
  "block.minecraft.banner.border.black": "Zwarte zoom",
  "block.minecraft.banner.border.blue": "Blauwe zoom",
  "block.minecraft.banner.border.brown": "Bruine zoom",
  "block.minecraft.banner.border.cyan": "Cyaan zoom",
  "block.minecraft.banner.border.gray": "Grijze zoom",
  "block.minecraft.banner.border.green": "Groene zoom",
  "block.minecraft.banner.border.light_blue": "Lichtblauwe zoom",
  "block.minecraft.banner.border.light_gray": "Lichtgrijze zoom",
  "block.minecraft.banner.border.lime": "Limoengroene zoom",
  "block.minecraft.banner.border.magenta": "Magenta zoom",
  "block.minecraft.banner.border.orange": "Oranje zoom",
  "block.minecraft.banner.border.pink": "Roze zoom",
  "block.minecraft.banner.border.purple": "Paarse zoom",
  "block.minecraft.banner.border.red": "Rode zoom",
  "block.minecraft.banner.border.white": "Witte zoom",
  "block.minecraft.banner.border.yellow": "Gele zoom",
  "block.minecraft.banner.bricks.black": "Zwart metselwerk",
  "block.minecraft.banner.bricks.blue": "Blauw metselwerk",
  "block.minecraft.banner.bricks.brown": "Bruin metselwerk",
  "block.minecraft.banner.bricks.cyan": "Cyaan metselwerk",
  "block.minecraft.banner.bricks.gray": "Grijs metselwerk",
  "block.minecraft.banner.bricks.green": "Groen metselwerk",
  "block.minecraft.banner.bricks.light_blue": "Lichtblauw metselwerk",
  "block.minecraft.banner.bricks.light_gray": "Lichtgrijs metselwerk",
  "block.minecraft.banner.bricks.lime": "Limoengroen metselwerk",
  "block.minecraft.banner.bricks.magenta": "Magenta metselwerk",
  "block.minecraft.banner.bricks.orange": "Oranje metselwerk",
  "block.minecraft.banner.bricks.pink": "Roze metselwerk",
  "block.minecraft.banner.bricks.purple": "Paars metselwerk",
  "block.minecraft.banner.bricks.red": "Rood metselwerk",
  "block.minecraft.banner.bricks.white": "Wit metselwerk",
  "block.minecraft.banner.bricks.yellow": "Geel metselwerk",
  "block.minecraft.banner.circle.black": "Zwart rozet",
  "block.minecraft.banner.circle.blue": "Blauw rozet",
  "block.minecraft.banner.circle.brown": "Bruin rozet",
  "block.minecraft.banner.circle.cyan": "Cyaan rozet",
  "block.minecraft.banner.circle.gray": "Grijs rozet",
  "block.minecraft.banner.circle.green": "Groen rozet",
  "block.minecraft.banner.circle.light_blue": "Lichtblauw rozet",
  "block.minecraft.banner.circle.light_gray": "Lichtgrijs rozet",
  "block.minecraft.banner.circle.lime": "Limoengroen rozet",
  "block.minecraft.banner.circle.magenta": "Magenta rozet",
  "block.minecraft.banner.circle.orange": "Oranje rozet",
  "block.minecraft.banner.circle.pink": "Roze rozet",
  "block.minecraft.banner.circle.purple": "Paars rozet",
  "block.minecraft.banner.circle.red": "Rood rozet",
  "block.minecraft.banner.circle.white": "Wit rozet",
  "block.minecraft.banner.circle.yellow": "Geel rozet",
  "block.minecraft.banner.creeper.black": "Zwart creeperwapen",
  "block.minecraft.banner.creeper.blue": "Blauw creeperwapen",
  "block.minecraft.banner.creeper.brown": "Bruin creeperwapen",
  "block.minecraft.banner.creeper.cyan": "Cyaan creeperwapen",
  "block.minecraft.banner.creeper.gray": "Grijs creeperwapen",
  "block.minecraft.banner.creeper.green": "Groen creeperwapen",
  "block.minecraft.banner.creeper.light_blue": "Lichtblauw creeperwapen",
  "block.minecraft.banner.creeper.light_gray": "Lichtgrijs creeperwapen",
  "block.minecraft.banner.creeper.lime": "Limoengroen creeperwapen",
  "block.minecraft.banner.creeper.magenta": "Magenta creeperwapen",
  "block.minecraft.banner.creeper.orange": "Oranje creeperwapen",
  "block.minecraft.banner.creeper.pink": "Roze creeperwapen",
  "block.minecraft.banner.creeper.purple": "Paars creeperwapen",
  "block.minecraft.banner.creeper.red": "Rood creeperwapen",
  "block.minecraft.banner.creeper.white": "Wit creeperwapen",
  "block.minecraft.banner.creeper.yellow": "Geel creeperwapen",
  "block.minecraft.banner.cross.black": "Zwart andreaskruis",
  "block.minecraft.banner.cross.blue": "Blauw andreaskruis",
  "block.minecraft.banner.cross.brown": "Bruin andreaskruis",
  "block.minecraft.banner.cross.cyan": "Cyaan andreaskruis",
  "block.minecraft.banner.cross.gray": "Grijs andreaskruis",
  "block.minecraft.banner.cross.green": "Groen andreaskruis",
  "block.minecraft.banner.cross.light_blue": "Lichtblauw andreaskruis",
  "block.minecraft.banner.cross.light_gray": "Lichtgrijs andreaskruis",
  "block.minecraft.banner.cross.lime": "Limoengroen andreaskruis",
  "block.minecraft.banner.cross.magenta": "Magenta andreaskruis",
  "block.minecraft.banner.cross.orange": "Oranje andreaskruis",
  "block.minecraft.banner.cross.pink": "Roze andreaskruis",
  "block.minecraft.banner.cross.purple": "Paars andreaskruis",
  "block.minecraft.banner.cross.red": "Rood andreaskruis",
  "block.minecraft.banner.cross.white": "Wit andreaskruis",
  "block.minecraft.banner.cross.yellow": "Geel andreaskruis",
  "block.minecraft.banner.curly_border.black": "Zwarte ingesprongen zoom",
  "block.minecraft.banner.curly_border.blue": "Blauwe ingesprongen zoom",
  "block.minecraft.banner.curly_border.brown": "Bruine ingesprongen zoom",
  "block.minecraft.banner.curly_border.cyan": "Cyaan ingesprongen zoom",
  "block.minecraft.banner.curly_border.gray": "Grijze ingesprongen zoom",
  "block.minecraft.banner.curly_border.green": "Groene ingesprongen zoom",
  "block.minecraft.banner.curly_border.light_blue": "Lichtblauwe ingesprongen zoom",
  "block.minecraft.banner.curly_border.light_gray": "Lichtgrijze ingesprongen zoom",
  "block.minecraft.banner.curly_border.lime": "Limoengroene ingesprongen zoom",
  "block.minecraft.banner.curly_border.magenta": "Magenta ingesprongen zoom",
  "block.minecraft.banner.curly_border.orange": "Oranje ingesprongen zoom",
  "block.minecraft.banner.curly_border.pink": "Roze ingesprongen zoom",
  "block.minecraft.banner.curly_border.purple": "Paarse ingesprongen zoom",
  "block.minecraft.banner.curly_border.red": "Rode ingesprongen zoom",
  "block.minecraft.banner.curly_border.white": "Witte ingesprongen zoom",
  "block.minecraft.banner.curly_border.yellow": "Gele ingesprongen zoom",
  "block.minecraft.banner.diagonal_left.black": "Zwart schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.blue": "Blauw schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.brown": "Bruin schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.cyan": "Cyaan schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.gray": "Grijs schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.green": "Groen schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.light_blue": "Lichtblauw schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.light_gray": "Lichtgrijs schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.lime": "Limoengroen schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.orange": "Oranje schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.pink": "Roze schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.purple": "Paars schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.red": "Rood schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.white": "Wit schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_left.yellow": "Geel schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_right.black": "Zwarte per band",
  "block.minecraft.banner.diagonal_right.blue": "Blauwe per band",
  "block.minecraft.banner.diagonal_right.brown": "Bruine per band",
  "block.minecraft.banner.diagonal_right.cyan": "Cyaan per band",
  "block.minecraft.banner.diagonal_right.gray": "Grijze per band",
  "block.minecraft.banner.diagonal_right.green": "Groene per band",
  "block.minecraft.banner.diagonal_right.light_blue": "Lichtblauwe per band",
  "block.minecraft.banner.diagonal_right.light_gray": "Lichtgrijze per band",
  "block.minecraft.banner.diagonal_right.lime": "Limoengroen per band",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta per band",
  "block.minecraft.banner.diagonal_right.orange": "Oranje per band",
  "block.minecraft.banner.diagonal_right.pink": "Roze per band",
  "block.minecraft.banner.diagonal_right.purple": "Paarse per band",
  "block.minecraft.banner.diagonal_right.red": "Rode per band",
  "block.minecraft.banner.diagonal_right.white": "Witte per band",
  "block.minecraft.banner.diagonal_right.yellow": "Gele per band",
  "block.minecraft.banner.diagonal_up_left.black": "Zwarte per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.blue": "Blauwe per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.brown": "Bruine per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyaan per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.gray": "Grijze per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.green": "Groene per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Lichtblauwe per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Lichtgrijze per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.lime": "Limoengroen omgekeerd schuinrechts verdeeld",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranje per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.pink": "Roze per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.purple": "Paarse per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.red": "Rode per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.white": "Witte per band omgekeerd",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gele per band omgekeerd",
  "block.minecraft.banner.diagonal_up_right.black": "Zwart omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.blue": "Blauw omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.brown": "Bruin omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyaan omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.gray": "Grijs omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.green": "Groen omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Lichtblauw omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Lichtgrijs omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.lime": "Limoengroen omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranje omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.pink": "Roze omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.purple": "Paars omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.red": "Rood omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.white": "Wit omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.diagonal_up_right.yellow": "Geel omgekeerd schuinlinks verdeeld",
  "block.minecraft.banner.flow.black": "Zwarte Stroom",
  "block.minecraft.banner.flow.blue": "Blauwe Stroom",
  "block.minecraft.banner.flow.brown": "Bruine Stroom",
  "block.minecraft.banner.flow.cyan": "Turquoise Stroom",
  "block.minecraft.banner.flow.gray": "Grijze Stroom",
  "block.minecraft.banner.flow.green": "Groene Stroom",
  "block.minecraft.banner.flow.light_blue": "Lichtblauwe Stroom",
  "block.minecraft.banner.flow.light_gray": "Lichtgrijze Stroom",
  "block.minecraft.banner.flow.lime": "Lichtgroene Stroom",
  "block.minecraft.banner.flow.magenta": "Magenta Stroom",
  "block.minecraft.banner.flow.orange": "Oranje Stroom",
  "block.minecraft.banner.flow.pink": "Roze Stroom",
  "block.minecraft.banner.flow.purple": "Paarse Stroom",
  "block.minecraft.banner.flow.red": "Rode Stroom",
  "block.minecraft.banner.flow.white": "Witte Stroom",
  "block.minecraft.banner.flow.yellow": "Gele Stroom",
  "block.minecraft.banner.flower.black": "Zwart bloemwapen",
  "block.minecraft.banner.flower.blue": "Blauw bloemwapen",
  "block.minecraft.banner.flower.brown": "Bruin bloemwapen",
  "block.minecraft.banner.flower.cyan": "Cyaan bloemwapen",
  "block.minecraft.banner.flower.gray": "Grijs bloemwapen",
  "block.minecraft.banner.flower.green": "Groen bloemwapen",
  "block.minecraft.banner.flower.light_blue": "Lichtblauw bloemwapen",
  "block.minecraft.banner.flower.light_gray": "Lichtgrijs bloemwapen",
  "block.minecraft.banner.flower.lime": "Limoengroen bloemwapen",
  "block.minecraft.banner.flower.magenta": "Magenta bloemwapen",
  "block.minecraft.banner.flower.orange": "Oranje bloemwapen",
  "block.minecraft.banner.flower.pink": "Roze bloemwapen",
  "block.minecraft.banner.flower.purple": "Paars bloemwapen",
  "block.minecraft.banner.flower.red": "Rood bloemwapen",
  "block.minecraft.banner.flower.white": "Wit bloemwapen",
  "block.minecraft.banner.flower.yellow": "Geel bloemwapen",
  "block.minecraft.banner.globe.black": "Zwarte aarde",
  "block.minecraft.banner.globe.blue": "Blauwe aarde",
  "block.minecraft.banner.globe.brown": "Bruine aarde",
  "block.minecraft.banner.globe.cyan": "Cyaan aarde",
  "block.minecraft.banner.globe.gray": "Grijze aarde",
  "block.minecraft.banner.globe.green": "Groene aarde",
  "block.minecraft.banner.globe.light_blue": "Lichtblauwe aarde",
  "block.minecraft.banner.globe.light_gray": "Lichtgrijze aarde",
  "block.minecraft.banner.globe.lime": "Limoengroene aarde",
  "block.minecraft.banner.globe.magenta": "Magenta aarde",
  "block.minecraft.banner.globe.orange": "Oranje aarde",
  "block.minecraft.banner.globe.pink": "Roze aarde",
  "block.minecraft.banner.globe.purple": "Paarse aarde",
  "block.minecraft.banner.globe.red": "Rode aarde",
  "block.minecraft.banner.globe.white": "Witte aarde",
  "block.minecraft.banner.globe.yellow": "Gele aarde",
  "block.minecraft.banner.gradient.black": "Zwart gradiënt",
  "block.minecraft.banner.gradient.blue": "Blauw gradiënt",
  "block.minecraft.banner.gradient.brown": "Bruin gradiënt",
  "block.minecraft.banner.gradient.cyan": "Cyaan gradiënt",
  "block.minecraft.banner.gradient.gray": "Grijs gradiënt",
  "block.minecraft.banner.gradient.green": "Groen gradiënt",
  "block.minecraft.banner.gradient.light_blue": "Lichtblauw gradiënt",
  "block.minecraft.banner.gradient.light_gray": "Lichtgrijs gradiënt",
  "block.minecraft.banner.gradient.lime": "Limoengroen gradiënt",
  "block.minecraft.banner.gradient.magenta": "Magenta gradiënt",
  "block.minecraft.banner.gradient.orange": "Oranje gradiënt",
  "block.minecraft.banner.gradient.pink": "Roze gradiënt",
  "block.minecraft.banner.gradient.purple": "Paars gradiënt",
  "block.minecraft.banner.gradient.red": "Rood gradiënt",
  "block.minecraft.banner.gradient.white": "Wit gradiënt",
  "block.minecraft.banner.gradient.yellow": "Geel gradiënt",
  "block.minecraft.banner.gradient_up.black": "Zwart basis gradiënt",
  "block.minecraft.banner.gradient_up.blue": "Blauw basis gradiënt",
  "block.minecraft.banner.gradient_up.brown": "Bruin basis gradiënt",
  "block.minecraft.banner.gradient_up.cyan": "Cyaan basis gradiënt",
  "block.minecraft.banner.gradient_up.gray": "Grijs basis gradiënt",
  "block.minecraft.banner.gradient_up.green": "Groen basis gradiënt",
  "block.minecraft.banner.gradient_up.light_blue": "Lichtblauw basis gradiënt",
  "block.minecraft.banner.gradient_up.light_gray": "Lichtgrijs basis gradiënt",
  "block.minecraft.banner.gradient_up.lime": "Limoengroen basis gradiënt",
  "block.minecraft.banner.gradient_up.magenta": "Magenta basis gradiënt",
  "block.minecraft.banner.gradient_up.orange": "Oranje basis gradiënt",
  "block.minecraft.banner.gradient_up.pink": "Roze basis gradiënt",
  "block.minecraft.banner.gradient_up.purple": "Paars basis gradiënt",
  "block.minecraft.banner.gradient_up.red": "Rood basis gradiënt",
  "block.minecraft.banner.gradient_up.white": "Wit basis gradiënt",
  "block.minecraft.banner.gradient_up.yellow": "Geel basis gradiënt",
  "block.minecraft.banner.guster.black": "Zwarte Windvlaag",
  "block.minecraft.banner.guster.blue": "Blauwe Windvlaag",
  "block.minecraft.banner.guster.brown": "Bruine Windvlaag",
  "block.minecraft.banner.guster.cyan": "Turquoise Windvlaag",
  "block.minecraft.banner.guster.gray": "Grijze Windvlaag",
  "block.minecraft.banner.guster.green": "Groene Windvlaag",
  "block.minecraft.banner.guster.light_blue": "Lichtblauwe Windvlaag",
  "block.minecraft.banner.guster.light_gray": "Lichtgrijze Windvlaag",
  "block.minecraft.banner.guster.lime": "Lichtgroene Windvlaag",
  "block.minecraft.banner.guster.magenta": "Magenta Windvlaag",
  "block.minecraft.banner.guster.orange": "Oranje Windvlaag",
  "block.minecraft.banner.guster.pink": "Roze Windvlaag",
  "block.minecraft.banner.guster.purple": "Paarse Windvlaag",
  "block.minecraft.banner.guster.red": "Rode Windvlaag",
  "block.minecraft.banner.guster.white": "Witte Windvlaag",
  "block.minecraft.banner.guster.yellow": "Gele Windvlaag",
  "block.minecraft.banner.half_horizontal.black": "Zwarte per faas",
  "block.minecraft.banner.half_horizontal.blue": "Blauwe per faas",
  "block.minecraft.banner.half_horizontal.brown": "Bruine per faas",
  "block.minecraft.banner.half_horizontal.cyan": "Cyaan per faas",
  "block.minecraft.banner.half_horizontal.gray": "Grijze per faas",
  "block.minecraft.banner.half_horizontal.green": "Groene per faas",
  "block.minecraft.banner.half_horizontal.light_blue": "Lichtblauwe per faas",
  "block.minecraft.banner.half_horizontal.light_gray": "Lichtgrijze per faas",
  "block.minecraft.banner.half_horizontal.lime": "Limoengroene per faas",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta per faas",
  "block.minecraft.banner.half_horizontal.orange": "Oranje per faas",
  "block.minecraft.banner.half_horizontal.pink": "Roze per faas",
  "block.minecraft.banner.half_horizontal.purple": "Paarse per faas",
  "block.minecraft.banner.half_horizontal.red": "Rode per faas",
  "block.minecraft.banner.half_horizontal.white": "Witte per faas",
  "block.minecraft.banner.half_horizontal.yellow": "Gele per faas",
  "block.minecraft.banner.half_horizontal_bottom.black": "Zwarte per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blauwe per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Bruine per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyaan per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grijze per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.green": "Groene per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Lichtblauwe per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Lichtgrijze per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Limoengroene per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranje per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roze per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Paarse per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.red": "Rode per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.white": "Witte per faas omgekeerd",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gele per faas omgekeerd",
  "block.minecraft.banner.half_vertical.black": "Zwarte per paal",
  "block.minecraft.banner.half_vertical.blue": "Blauwe per paal",
  "block.minecraft.banner.half_vertical.brown": "Bruine per paal",
  "block.minecraft.banner.half_vertical.cyan": "Cyaan per paal",
  "block.minecraft.banner.half_vertical.gray": "Grijze per paal",
  "block.minecraft.banner.half_vertical.green": "Groene per paal",
  "block.minecraft.banner.half_vertical.light_blue": "Lichtblauwe per paal",
  "block.minecraft.banner.half_vertical.light_gray": "Lichtgrijze per paal",
  "block.minecraft.banner.half_vertical.lime": "Limoengroene per paal",
  "block.minecraft.banner.half_vertical.magenta": "Magenta per paal",
  "block.minecraft.banner.half_vertical.orange": "Oranje per paal",
  "block.minecraft.banner.half_vertical.pink": "Roze per paal",
  "block.minecraft.banner.half_vertical.purple": "Paarse per paal",
  "block.minecraft.banner.half_vertical.red": "Rode per paal",
  "block.minecraft.banner.half_vertical.white": "Witte per paal",
  "block.minecraft.banner.half_vertical.yellow": "Gele per paal",
  "block.minecraft.banner.half_vertical_right.black": "Zwarte per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.blue": "Blauwe per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.brown": "Bruine per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.cyan": "Cyaan per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.gray": "Grijze per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.green": "Groene per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.light_blue": "Lichtblauwe per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.light_gray": "Lichtgrijze per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.lime": "Limoengroene per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.orange": "Oranje per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.pink": "Roze per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.purple": "Paarse per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.red": "Rode per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.white": "Witte per paal omgekeerd",
  "block.minecraft.banner.half_vertical_right.yellow": "Gele per paal omgekeerd",
  "block.minecraft.banner.mojang.black": "Zwart Mojangwapen",
  "block.minecraft.banner.mojang.blue": "Blauw Mojangwapen",
  "block.minecraft.banner.mojang.brown": "Bruin Mojangwapen",
  "block.minecraft.banner.mojang.cyan": "Cyaan Mojangwapen",
  "block.minecraft.banner.mojang.gray": "Grijs Mojangwapen",
  "block.minecraft.banner.mojang.green": "Groen Mojangwapen",
  "block.minecraft.banner.mojang.light_blue": "Lichtblauw Mojangwapen",
  "block.minecraft.banner.mojang.light_gray": "Lightgrijs Mojangwapen",
  "block.minecraft.banner.mojang.lime": "Limoengroen Mojangwapen",
  "block.minecraft.banner.mojang.magenta": "Magenta Mojangwapen",
  "block.minecraft.banner.mojang.orange": "Oranje Mojangwapen",
  "block.minecraft.banner.mojang.pink": "Roze Mojangwapen",
  "block.minecraft.banner.mojang.purple": "Paars Mojangwapen",
  "block.minecraft.banner.mojang.red": "Rood Mojangwapen",
  "block.minecraft.banner.mojang.white": "Wit Mojangwapen",
  "block.minecraft.banner.mojang.yellow": "Geel Mojangwapen",
  "block.minecraft.banner.piglin.black": "Zwarte snuit",
  "block.minecraft.banner.piglin.blue": "Blauwe snuit",
  "block.minecraft.banner.piglin.brown": "Bruine snuit",
  "block.minecraft.banner.piglin.cyan": "Cyaan snuit",
  "block.minecraft.banner.piglin.gray": "Grijze snuit",
  "block.minecraft.banner.piglin.green": "Groene snuit",
  "block.minecraft.banner.piglin.light_blue": "Lichtblauwe snuit",
  "block.minecraft.banner.piglin.light_gray": "Lichtgrijze snuit",
  "block.minecraft.banner.piglin.lime": "Limoengroene snuit",
  "block.minecraft.banner.piglin.magenta": "Magenta snuit",
  "block.minecraft.banner.piglin.orange": "Oranje snuit",
  "block.minecraft.banner.piglin.pink": "Roze snuit",
  "block.minecraft.banner.piglin.purple": "Paarse snuit",
  "block.minecraft.banner.piglin.red": "Rode snuit",
  "block.minecraft.banner.piglin.white": "Witte snuit",
  "block.minecraft.banner.piglin.yellow": "Gele snuit",
  "block.minecraft.banner.rhombus.black": "Zwarte ruit",
  "block.minecraft.banner.rhombus.blue": "Blauwe ruit",
  "block.minecraft.banner.rhombus.brown": "Bruine ruit",
  "block.minecraft.banner.rhombus.cyan": "Cyaan ruit",
  "block.minecraft.banner.rhombus.gray": "Grijze ruit",
  "block.minecraft.banner.rhombus.green": "Groene ruit",
  "block.minecraft.banner.rhombus.light_blue": "Lichtblauwe ruit",
  "block.minecraft.banner.rhombus.light_gray": "Lichtgrijze ruit",
  "block.minecraft.banner.rhombus.lime": "Limoengroene ruit",
  "block.minecraft.banner.rhombus.magenta": "Magenta ruit",
  "block.minecraft.banner.rhombus.orange": "Oranje ruit",
  "block.minecraft.banner.rhombus.pink": "Roze ruit",
  "block.minecraft.banner.rhombus.purple": "Paarse ruit",
  "block.minecraft.banner.rhombus.red": "Rode ruit",
  "block.minecraft.banner.rhombus.white": "Witte ruit",
  "block.minecraft.banner.rhombus.yellow": "Gele ruit",
  "block.minecraft.banner.skull.black": "Zwart schedelwapen",
  "block.minecraft.banner.skull.blue": "Blauw schedelwapen",
  "block.minecraft.banner.skull.brown": "Bruin schedelwapen",
  "block.minecraft.banner.skull.cyan": "Cyaan schedelwapen",
  "block.minecraft.banner.skull.gray": "Grijs schedelwapen",
  "block.minecraft.banner.skull.green": "Groen schedelwapen",
  "block.minecraft.banner.skull.light_blue": "Lichtblauw schedelwapen",
  "block.minecraft.banner.skull.light_gray": "Lichtgrijs schedelwapen",
  "block.minecraft.banner.skull.lime": "Limoengroen schedelwapen",
  "block.minecraft.banner.skull.magenta": "Magenta schedelwapen",
  "block.minecraft.banner.skull.orange": "Oranje schedelwapen",
  "block.minecraft.banner.skull.pink": "Roze schedelwapen",
  "block.minecraft.banner.skull.purple": "Paars schedelwapen",
  "block.minecraft.banner.skull.red": "Rood schedelwapen",
  "block.minecraft.banner.skull.white": "Wit schedelwapen",
  "block.minecraft.banner.skull.yellow": "Geel schedelwapen",
  "block.minecraft.banner.small_stripes.black": "Zwarte palen",
  "block.minecraft.banner.small_stripes.blue": "Blauwe palen",
  "block.minecraft.banner.small_stripes.brown": "Bruine palen",
  "block.minecraft.banner.small_stripes.cyan": "Cyaan palen",
  "block.minecraft.banner.small_stripes.gray": "Grijze palen",
  "block.minecraft.banner.small_stripes.green": "Groene palen",
  "block.minecraft.banner.small_stripes.light_blue": "Lichtblauwe palen",
  "block.minecraft.banner.small_stripes.light_gray": "Lichtgrijze palen",
  "block.minecraft.banner.small_stripes.lime": "Limoengroene palen",
  "block.minecraft.banner.small_stripes.magenta": "Magenta palen",
  "block.minecraft.banner.small_stripes.orange": "Oranje palen",
  "block.minecraft.banner.small_stripes.pink": "Roze palen",
  "block.minecraft.banner.small_stripes.purple": "Paarse palen",
  "block.minecraft.banner.small_stripes.red": "Rode palen",
  "block.minecraft.banner.small_stripes.white": "Witte palen",
  "block.minecraft.banner.small_stripes.yellow": "Gele palen",
  "block.minecraft.banner.square_bottom_left.black": "Zwart kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.blue": "Blauw kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.brown": "Bruin kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.cyan": "Cyaan kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.gray": "Grijs kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.green": "Groen kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.light_blue": "Lichtblauw kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.light_gray": "Lichtgrijs kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.lime": "Limoengroen kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.orange": "Oranje kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.pink": "Roze kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.purple": "Paars kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.red": "Rood kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.white": "Wit kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_left.yellow": "Geel kwartier rechtsonder",
  "block.minecraft.banner.square_bottom_right.black": "Zwart kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.blue": "Blauw kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.brown": "Bruin kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.cyan": "Cyaan kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.gray": "Grijs kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.green": "Groen kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.light_blue": "Lichtblauw kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.light_gray": "Lichtgrijs kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.lime": "Limoengroen kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.orange": "Oranje kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.pink": "Roze kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.purple": "Paars kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.red": "Rood kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.white": "Wit kwartier linksonder",
  "block.minecraft.banner.square_bottom_right.yellow": "Geel kwartier linksonder",
  "block.minecraft.banner.square_top_left.black": "Zwart kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.blue": "Blauw kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.brown": "Bruin kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.cyan": "Cyaan kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.gray": "Grijs kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.green": "Groen kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.light_blue": "Lichtblauw kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.light_gray": "Lichtgrijs kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.lime": "Limoengroen kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.magenta": "Magenta kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.orange": "Oranje kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.pink": "Roze kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.purple": "Paars kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.red": "Rood kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.white": "Wit kwartier rechtsboven",
  "block.minecraft.banner.square_top_left.yellow": "Geel kwartier rechtsboven",
  "block.minecraft.banner.square_top_right.black": "Zwart kwartier linksboven",
  "block.minecraft.banner.square_top_right.blue": "Blauw kwartier linksboven",
  "block.minecraft.banner.square_top_right.brown": "Bruin kwartier linksboven",
  "block.minecraft.banner.square_top_right.cyan": "Cyaan kwartier linksboven",
  "block.minecraft.banner.square_top_right.gray": "Grijs kwartier linksboven",
  "block.minecraft.banner.square_top_right.green": "Groen kwartier linksboven",
  "block.minecraft.banner.square_top_right.light_blue": "Lichtblauw kwartier linksboven",
  "block.minecraft.banner.square_top_right.light_gray": "Lichtgrijs kwartier linksboven",
  "block.minecraft.banner.square_top_right.lime": "Limoengroen kwartier linksboven",
  "block.minecraft.banner.square_top_right.magenta": "Magenta kwartier linksboven",
  "block.minecraft.banner.square_top_right.orange": "Oranje kwartier linksboven",
  "block.minecraft.banner.square_top_right.pink": "Roze kwartier linksboven",
  "block.minecraft.banner.square_top_right.purple": "Paars kwartier linksboven",
  "block.minecraft.banner.square_top_right.red": "Rood kwartier linksboven",
  "block.minecraft.banner.square_top_right.white": "Wit kwartier linksboven",
  "block.minecraft.banner.square_top_right.yellow": "Geel kwartier linksboven",
  "block.minecraft.banner.straight_cross.black": "Zwart kruis",
  "block.minecraft.banner.straight_cross.blue": "Blauw kruis",
  "block.minecraft.banner.straight_cross.brown": "Bruin kruis",
  "block.minecraft.banner.straight_cross.cyan": "Cyaan kruis",
  "block.minecraft.banner.straight_cross.gray": "Grijs kruis",
  "block.minecraft.banner.straight_cross.green": "Groen kruis",
  "block.minecraft.banner.straight_cross.light_blue": "Lichtblauw kruis",
  "block.minecraft.banner.straight_cross.light_gray": "Lichtgrijs kruis",
  "block.minecraft.banner.straight_cross.lime": "Limoengroen kruis",
  "block.minecraft.banner.straight_cross.magenta": "Magenta kruis",
  "block.minecraft.banner.straight_cross.orange": "Oranje kruis",
  "block.minecraft.banner.straight_cross.pink": "Roze kruis",
  "block.minecraft.banner.straight_cross.purple": "Paars kruis",
  "block.minecraft.banner.straight_cross.red": "Rood kruis",
  "block.minecraft.banner.straight_cross.white": "Wit kruis",
  "block.minecraft.banner.straight_cross.yellow": "Geel kruis",
  "block.minecraft.banner.stripe_bottom.black": "Zwarte basis",
  "block.minecraft.banner.stripe_bottom.blue": "Blauwe basis",
  "block.minecraft.banner.stripe_bottom.brown": "Bruine basis",
  "block.minecraft.banner.stripe_bottom.cyan": "Cyaan basis",
  "block.minecraft.banner.stripe_bottom.gray": "Grijze basis",
  "block.minecraft.banner.stripe_bottom.green": "Groene basis",
  "block.minecraft.banner.stripe_bottom.light_blue": "Lichtblauwe basis",
  "block.minecraft.banner.stripe_bottom.light_gray": "Lichtgrijze basis",
  "block.minecraft.banner.stripe_bottom.lime": "Limoengroene basis",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta basis",
  "block.minecraft.banner.stripe_bottom.orange": "Oranje basis",
  "block.minecraft.banner.stripe_bottom.pink": "Roze basis",
  "block.minecraft.banner.stripe_bottom.purple": "Paarse basis",
  "block.minecraft.banner.stripe_bottom.red": "Rode basis",
  "block.minecraft.banner.stripe_bottom.white": "Witte basis",
  "block.minecraft.banner.stripe_bottom.yellow": "Gele basis",
  "block.minecraft.banner.stripe_center.black": "Zwarte paal",
  "block.minecraft.banner.stripe_center.blue": "Blauwe paal",
  "block.minecraft.banner.stripe_center.brown": "Bruine paal",
  "block.minecraft.banner.stripe_center.cyan": "Cyaan paal",
  "block.minecraft.banner.stripe_center.gray": "Grijze paal",
  "block.minecraft.banner.stripe_center.green": "Groene paal",
  "block.minecraft.banner.stripe_center.light_blue": "Lichtblauwe paal",
  "block.minecraft.banner.stripe_center.light_gray": "Lichtgrijze paal",
  "block.minecraft.banner.stripe_center.lime": "Limoengroene paal",
  "block.minecraft.banner.stripe_center.magenta": "Magenta paal",
  "block.minecraft.banner.stripe_center.orange": "Oranje paal",
  "block.minecraft.banner.stripe_center.pink": "Roze paal",
  "block.minecraft.banner.stripe_center.purple": "Paarse paal",
  "block.minecraft.banner.stripe_center.red": "Rode paal",
  "block.minecraft.banner.stripe_center.white": "Witte paal",
  "block.minecraft.banner.stripe_center.yellow": "Gele paal",
  "block.minecraft.banner.stripe_downleft.black": "Zwarte linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.blue": "Blauwe linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.brown": "Bruine linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyaan linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.gray": "Grijze linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.green": "Groene linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.light_blue": "Lichtblauwe linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.light_gray": "Lichtgrijze linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.lime": "Limoengroene linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.orange": "Oranje linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.pink": "Roze linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.purple": "Paarse linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.red": "Rode linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.white": "Witte linkerschuinbalk",
  "block.minecraft.banner.stripe_downleft.yellow": "Gele linkerschuinbalk",
  "block.minecraft.banner.stripe_downright.black": "Zwarte rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.blue": "Blauwe rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.brown": "Bruine rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.cyan": "Cyaan rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.gray": "Grijze rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.green": "Groene rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.light_blue": "Lichtblauwe rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.light_gray": "Lichtgrijze rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.lime": "Limoengroene rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.orange": "Oranje rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.pink": "Roze rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.purple": "Paarse rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.red": "Rode rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.white": "Witte rechterschuinbalk",
  "block.minecraft.banner.stripe_downright.yellow": "Gele rechterschuinbalk",
  "block.minecraft.banner.stripe_left.black": "Zwarte rechterpaal",
  "block.minecraft.banner.stripe_left.blue": "Blauwe rechterpaal",
  "block.minecraft.banner.stripe_left.brown": "Bruine rechterpaal",
  "block.minecraft.banner.stripe_left.cyan": "Cyaan rechterpaal",
  "block.minecraft.banner.stripe_left.gray": "Grijze rechterpaal",
  "block.minecraft.banner.stripe_left.green": "Groene rechterpaal",
  "block.minecraft.banner.stripe_left.light_blue": "Lichtblauwe rechterpaal",
  "block.minecraft.banner.stripe_left.light_gray": "Lichtgrijze rechterpaal",
  "block.minecraft.banner.stripe_left.lime": "Limoengroene rechterpaal",
  "block.minecraft.banner.stripe_left.magenta": "Magenta rechterpaal",
  "block.minecraft.banner.stripe_left.orange": "Oranje rechterpaal",
  "block.minecraft.banner.stripe_left.pink": "Roze rechterpaal",
  "block.minecraft.banner.stripe_left.purple": "Paarse rechterpaal",
  "block.minecraft.banner.stripe_left.red": "Rode rechterpaal",
  "block.minecraft.banner.stripe_left.white": "Witte rechterpaal",
  "block.minecraft.banner.stripe_left.yellow": "Gele rechterpaal",
  "block.minecraft.banner.stripe_middle.black": "Zwarte faas",
  "block.minecraft.banner.stripe_middle.blue": "Blauwe faas",
  "block.minecraft.banner.stripe_middle.brown": "Bruine faas",
  "block.minecraft.banner.stripe_middle.cyan": "Cyaan faas",
  "block.minecraft.banner.stripe_middle.gray": "Grijze faas",
  "block.minecraft.banner.stripe_middle.green": "Groene faas",
  "block.minecraft.banner.stripe_middle.light_blue": "Lichtblauwe faas",
  "block.minecraft.banner.stripe_middle.light_gray": "Lichtgrijze faas",
  "block.minecraft.banner.stripe_middle.lime": "Limoengroene balk",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta faas",
  "block.minecraft.banner.stripe_middle.orange": "Oranje faas",
  "block.minecraft.banner.stripe_middle.pink": "Roze faas",
  "block.minecraft.banner.stripe_middle.purple": "Paarse faas",
  "block.minecraft.banner.stripe_middle.red": "Rode faas",
  "block.minecraft.banner.stripe_middle.white": "Witte faas",
  "block.minecraft.banner.stripe_middle.yellow": "Gele faas",
  "block.minecraft.banner.stripe_right.black": "Zwarte linkerpaal",
  "block.minecraft.banner.stripe_right.blue": "Blauwe linkerpaal",
  "block.minecraft.banner.stripe_right.brown": "Bruine linkerpaal",
  "block.minecraft.banner.stripe_right.cyan": "Cyaan linkerpaal",
  "block.minecraft.banner.stripe_right.gray": "Grijze linkerpaal",
  "block.minecraft.banner.stripe_right.green": "Groene linkerpaal",
  "block.minecraft.banner.stripe_right.light_blue": "Lichtblauwe linkerpaal",
  "block.minecraft.banner.stripe_right.light_gray": "Lichtgrijze linkerpaal",
  "block.minecraft.banner.stripe_right.lime": "Limoengroene linkerpaal",
  "block.minecraft.banner.stripe_right.magenta": "Magenta linkerpaal",
  "block.minecraft.banner.stripe_right.orange": "Oranje linkerpaal",
  "block.minecraft.banner.stripe_right.pink": "Roze linkerpaal",
  "block.minecraft.banner.stripe_right.purple": "Paarse linkerpaal",
  "block.minecraft.banner.stripe_right.red": "Rode linkerpaal",
  "block.minecraft.banner.stripe_right.white": "Witte linkerpaal",
  "block.minecraft.banner.stripe_right.yellow": "Gele linkerpaal",
  "block.minecraft.banner.stripe_top.black": "Zwarte top",
  "block.minecraft.banner.stripe_top.blue": "Blauwe top",
  "block.minecraft.banner.stripe_top.brown": "Bruine top",
  "block.minecraft.banner.stripe_top.cyan": "Cyaan top",
  "block.minecraft.banner.stripe_top.gray": "Grijze top",
  "block.minecraft.banner.stripe_top.green": "Groene top",
  "block.minecraft.banner.stripe_top.light_blue": "Lichtblauwe top",
  "block.minecraft.banner.stripe_top.light_gray": "Lichtgrijze top",
  "block.minecraft.banner.stripe_top.lime": "Limoengroene top",
  "block.minecraft.banner.stripe_top.magenta": "Magenta top",
  "block.minecraft.banner.stripe_top.orange": "Oranje top",
  "block.minecraft.banner.stripe_top.pink": "Roze top",
  "block.minecraft.banner.stripe_top.purple": "Paarse top",
  "block.minecraft.banner.stripe_top.red": "Rode top",
  "block.minecraft.banner.stripe_top.white": "Witte top",
  "block.minecraft.banner.stripe_top.yellow": "Gele top",
  "block.minecraft.banner.triangle_bottom.black": "Zwarte keper",
  "block.minecraft.banner.triangle_bottom.blue": "Blauwe keper",
  "block.minecraft.banner.triangle_bottom.brown": "Bruine keper",
  "block.minecraft.banner.triangle_bottom.cyan": "Cyaan keper",
  "block.minecraft.banner.triangle_bottom.gray": "Grijze keper",
  "block.minecraft.banner.triangle_bottom.green": "Groene keper",
  "block.minecraft.banner.triangle_bottom.light_blue": "Lichtblauwe keper",
  "block.minecraft.banner.triangle_bottom.light_gray": "Lichtgrijze keper",
  "block.minecraft.banner.triangle_bottom.lime": "Limoengroene keper",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta keper",
  "block.minecraft.banner.triangle_bottom.orange": "Oranje keper",
  "block.minecraft.banner.triangle_bottom.pink": "Roze keper",
  "block.minecraft.banner.triangle_bottom.purple": "Paarse keper",
  "block.minecraft.banner.triangle_bottom.red": "Rode keper",
  "block.minecraft.banner.triangle_bottom.white": "Witte keper",
  "block.minecraft.banner.triangle_bottom.yellow": "Gele keper",
  "block.minecraft.banner.triangle_top.black": "Zwarte omgekeerde keper",
  "block.minecraft.banner.triangle_top.blue": "Blauwe omgekeerde keper",
  "block.minecraft.banner.triangle_top.brown": "Bruine omgekeerde keper",
  "block.minecraft.banner.triangle_top.cyan": "Cyaan omgekeerde keper",
  "block.minecraft.banner.triangle_top.gray": "Grijze omgekeerde keper",
  "block.minecraft.banner.triangle_top.green": "Groene omgekeerde keper",
  "block.minecraft.banner.triangle_top.light_blue": "Lichtblauwe omgekeerde keper",
  "block.minecraft.banner.triangle_top.light_gray": "Lichtgrijze omgekeerde keper",
  "block.minecraft.banner.triangle_top.lime": "Limoengroene omgekeerde keper",
  "block.minecraft.banner.triangle_top.magenta": "Magenta omgekeerde keper",
  "block.minecraft.banner.triangle_top.orange": "Oranje omgekeerde keper",
  "block.minecraft.banner.triangle_top.pink": "Roze omgekeerde keper",
  "block.minecraft.banner.triangle_top.purple": "Paarse omgekeerde keper",
  "block.minecraft.banner.triangle_top.red": "Rode omgekeerde keper",
  "block.minecraft.banner.triangle_top.white": "Witte omgekeerde keper",
  "block.minecraft.banner.triangle_top.yellow": "Gele omgekeerde keper",
  "block.minecraft.banner.triangles_bottom.black": "Zwarte ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.blue": "Blauwe ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.brown": "Bruine ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.cyan": "Cyaan ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.gray": "Grijze ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.green": "Groene ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.light_blue": "Lichtblauwe ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.light_gray": "Lichtgrijze ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.lime": "Limoengroene ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.orange": "Oranje ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.pink": "Roze ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.purple": "Paarse ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.red": "Rode ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.white": "Witte ingesprongen basis",
  "block.minecraft.banner.triangles_bottom.yellow": "Gele ingesprongen basis",
  "block.minecraft.banner.triangles_top.black": "Zwart ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.blue": "Blauw ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.brown": "Bruin ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.cyan": "Cyaan ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.gray": "Grijs ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.green": "Groen ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.light_blue": "Lichtblauw ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.light_gray": "Lichtgrijs ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.lime": "Limoengroen ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.magenta": "Magenta ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.orange": "Oranje ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.pink": "Roze ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.purple": "Paars ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.red": "Rood ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.white": "Wit ingesprongen hoofd",
  "block.minecraft.banner.triangles_top.yellow": "Geel ingesprongen hoofd",
  "block.minecraft.barrel": "Vat",
  "block.minecraft.barrier": "Barrière",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Baken",
  "block.minecraft.beacon.primary": "Primaire kracht",
  "block.minecraft.beacon.secondary": "Secundaire kracht",
  "block.minecraft.bed.no_sleep": "U kunt alleen 's nachts of tijdens onweer slapen",
  "block.minecraft.bed.not_safe": "U kunt nu niet slapen; er zijn monsters in de buurt",
  "block.minecraft.bed.obstructed": "Dit bed is geblokkeerd",
  "block.minecraft.bed.occupied": "Dit bed is bezet",
  "block.minecraft.bed.too_far_away": "U kunt nu niet slapen; het bed is te ver weg",
  "block.minecraft.bedrock": "Bodemsteen",
  "block.minecraft.bee_nest": "Bijennest",
  "block.minecraft.beehive": "Bijenkorf",
  "block.minecraft.beetroots": "Bieten",
  "block.minecraft.bell": "Bel",
  "block.minecraft.big_dripleaf": "Groot druipblad",
  "block.minecraft.big_dripleaf_stem": "Grote druipbladstengel",
  "block.minecraft.birch_button": "Berken knop",
  "block.minecraft.birch_door": "Berken deur",
  "block.minecraft.birch_fence": "Berkenhouten hek",
  "block.minecraft.birch_fence_gate": "Berkenhouten poort",
  "block.minecraft.birch_hanging_sign": "Berkenhouten hangbord",
  "block.minecraft.birch_leaves": "Berkenbladeren",
  "block.minecraft.birch_log": "Berkenstam",
  "block.minecraft.birch_planks": "Berken planken",
  "block.minecraft.birch_pressure_plate": "Berken drukplaat",
  "block.minecraft.birch_sapling": "Berkenkiemplant",
  "block.minecraft.birch_shelf": "Berkenhouten plank",
  "block.minecraft.birch_sign": "Berken bord",
  "block.minecraft.birch_slab": "Berken plaat",
  "block.minecraft.birch_stairs": "Berken trap",
  "block.minecraft.birch_trapdoor": "Berken valluik",
  "block.minecraft.birch_wall_hanging_sign": "Berkenhouten uithangbord",
  "block.minecraft.birch_wall_sign": "Eiken bord aan muur",
  "block.minecraft.birch_wood": "Berkenhout",
  "block.minecraft.black_banner": "Zwarte vlag",
  "block.minecraft.black_bed": "Zwart bed",
  "block.minecraft.black_candle": "Zwarte kaars",
  "block.minecraft.black_candle_cake": "Taart met zwarte kaars",
  "block.minecraft.black_carpet": "Zwart tapijt",
  "block.minecraft.black_concrete": "Zwart beton",
  "block.minecraft.black_concrete_powder": "Zwart cement",
  "block.minecraft.black_glazed_terracotta": "Zwartgeglazuurde terracotta",
  "block.minecraft.black_shulker_box": "Zwarte Shulkerdoos",
  "block.minecraft.black_stained_glass": "Zwartgekleurd glas",
  "block.minecraft.black_stained_glass_pane": "Zwartgekleurde glazen ruit",
  "block.minecraft.black_terracotta": "Zwart terracotta",
  "block.minecraft.black_wool": "Zwarte wol",
  "block.minecraft.blackstone": "Zwartsteen",
  "block.minecraft.blackstone_slab": "Zwartstenen plaat",
  "block.minecraft.blackstone_stairs": "Zwartstenen trap",
  "block.minecraft.blackstone_wall": "Zwartstenen muur",
  "block.minecraft.blast_furnace": "Hoogoven",
  "block.minecraft.blue_banner": "Blauwe vlag",
  "block.minecraft.blue_bed": "Blauw bed",
  "block.minecraft.blue_candle": "Blauwe kaars",
  "block.minecraft.blue_candle_cake": "Taart met blauwe kaars",
  "block.minecraft.blue_carpet": "Blauw tapijt",
  "block.minecraft.blue_concrete": "Blauw beton",
  "block.minecraft.blue_concrete_powder": "Blauw cement",
  "block.minecraft.blue_glazed_terracotta": "Blauwgeglazuurde terracotta",
  "block.minecraft.blue_ice": "Blauw ijs",
  "block.minecraft.blue_orchid": "Blauwe orchidee",
  "block.minecraft.blue_shulker_box": "Blauwe Shulkerdoos",
  "block.minecraft.blue_stained_glass": "Blauwgekleurd glas",
  "block.minecraft.blue_stained_glass_pane": "Blauwgekleurde glazen ruit",
  "block.minecraft.blue_terracotta": "Blauw terracotta",
  "block.minecraft.blue_wool": "Blauwe wol",
  "block.minecraft.bone_block": "Bottenblok",
  "block.minecraft.bookshelf": "Boekenkast",
  "block.minecraft.brain_coral": "Hersenkoraal",
  "block.minecraft.brain_coral_block": "Hersenkoraalblok",
  "block.minecraft.brain_coral_fan": "Hersenkoraalwaaier",
  "block.minecraft.brain_coral_wall_fan": "Hersenkoraalwaaier aan muur",
  "block.minecraft.brewing_stand": "Brouwstandaard",
  "block.minecraft.brick_slab": "Bakstenen plaat",
  "block.minecraft.brick_stairs": "Bakstenen trap",
  "block.minecraft.brick_wall": "Bakstenen muur",
  "block.minecraft.bricks": "Bakstenen",
  "block.minecraft.brown_banner": "Bruine vlag",
  "block.minecraft.brown_bed": "Bruin bed",
  "block.minecraft.brown_candle": "Bruine kaars",
  "block.minecraft.brown_candle_cake": "Taart met bruine kaars",
  "block.minecraft.brown_carpet": "Bruin tapijt",
  "block.minecraft.brown_concrete": "Bruin beton",
  "block.minecraft.brown_concrete_powder": "Bruin cement",
  "block.minecraft.brown_glazed_terracotta": "Bruingeglazuurde terracotta",
  "block.minecraft.brown_mushroom": "Bruine paddenstoel",
  "block.minecraft.brown_mushroom_block": "Bruin paddenstoelenblok",
  "block.minecraft.brown_shulker_box": "Bruine Shulkerdoos",
  "block.minecraft.brown_stained_glass": "Bruingekleurd glas",
  "block.minecraft.brown_stained_glass_pane": "Bruingekleurde glazen ruit",
  "block.minecraft.brown_terracotta": "Bruin terracotta",
  "block.minecraft.brown_wool": "Bruine wol",
  "block.minecraft.bubble_column": "Bellenkolom",
  "block.minecraft.bubble_coral": "Blaaskoraal",
  "block.minecraft.bubble_coral_block": "Blaaskoraalblok",
  "block.minecraft.bubble_coral_fan": "Blaaskoraalwaaier",
  "block.minecraft.bubble_coral_wall_fan": "Blaaskoraalwaaier aan muur",
  "block.minecraft.budding_amethyst": "Uitlopende amethist",
  "block.minecraft.bush": "Struik",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Cactusbloem",
  "block.minecraft.cake": "Taart",
  "block.minecraft.calcite": "Calciet",
  "block.minecraft.calibrated_sculk_sensor": "Gekalibreerde sculksensor",
  "block.minecraft.campfire": "Kampvuur",
  "block.minecraft.candle": "Kaars",
  "block.minecraft.candle_cake": "Taart met kaars",
  "block.minecraft.carrots": "Wortels",
  "block.minecraft.cartography_table": "Cartografietafel",
  "block.minecraft.carved_pumpkin": "Bewerkte pompoen",
  "block.minecraft.cauldron": "Ketel",
  "block.minecraft.cave_air": "Grotlucht",
  "block.minecraft.cave_vines": "Grottenlianen",
  "block.minecraft.cave_vines_plant": "Grottenlianenplant",
  "block.minecraft.chain": "Ketting",
  "block.minecraft.chain_command_block": "Gekoppeld opdrachtblok",
  "block.minecraft.cherry_button": "Kersenhouten knop",
  "block.minecraft.cherry_door": "Kersenhouten deur",
  "block.minecraft.cherry_fence": "Kersenhouten hek",
  "block.minecraft.cherry_fence_gate": "Kersenhouten poortje",
  "block.minecraft.cherry_hanging_sign": "Kersenhout hangbord",
  "block.minecraft.cherry_leaves": "Kersenbladeren",
  "block.minecraft.cherry_log": "Kersenboomstam",
  "block.minecraft.cherry_planks": "Kersenhouten planken",
  "block.minecraft.cherry_pressure_plate": "Kersenhouten drukplaat",
  "block.minecraft.cherry_sapling": "Kersenzaailing",
  "block.minecraft.cherry_shelf": "Kersenhouten plank",
  "block.minecraft.cherry_sign": "Kersenhouten bord",
  "block.minecraft.cherry_slab": "Kersenhouten plaat",
  "block.minecraft.cherry_stairs": "Kersenhouten trap",
  "block.minecraft.cherry_trapdoor": "Kersenhouten valluik",
  "block.minecraft.cherry_wall_hanging_sign": "Kersenhouten uithangbord",
  "block.minecraft.cherry_wall_sign": "Kersenhouten bord aan muur",
  "block.minecraft.cherry_wood": "Kersenhout",
  "block.minecraft.chest": "Kist",
  "block.minecraft.chipped_anvil": "Gebarsten aanvil",
  "block.minecraft.chiseled_bookshelf": "Bewerkte boekenkast",
  "block.minecraft.chiseled_copper": "Gebeiteld Koper",
  "block.minecraft.chiseled_deepslate": "Gebeiteld wrevelsteen",
  "block.minecraft.chiseled_nether_bricks": "Gebeitelde Netherbakstenen",
  "block.minecraft.chiseled_polished_blackstone": "Gebeiteld gepolijst zwartsteen",
  "block.minecraft.chiseled_quartz_block": "Gebeiteld kwartsblok",
  "block.minecraft.chiseled_red_sandstone": "Gebeiteld rood zandsteen",
  "block.minecraft.chiseled_resin_bricks": "Gebeitelde harsbakstenen",
  "block.minecraft.chiseled_sandstone": "Gebeiteld zandsteen",
  "block.minecraft.chiseled_stone_bricks": "Gebeitelde blokstenen",
  "block.minecraft.chiseled_tuff": "Gebeiteld tufsteen",
  "block.minecraft.chiseled_tuff_bricks": "Gebeitelde tufstenen bakstenen",
  "block.minecraft.chorus_flower": "Chorusbloem",
  "block.minecraft.chorus_plant": "Chorusplant",
  "block.minecraft.clay": "Klei",
  "block.minecraft.closed_eyeblossom": "Gesloten gluurbloesem",
  "block.minecraft.coal_block": "Steenkoolblok",
  "block.minecraft.coal_ore": "Steenkool",
  "block.minecraft.coarse_dirt": "Grove aarde",
  "block.minecraft.cobbled_deepslate": "Geplaveid wrevelsteen",
  "block.minecraft.cobbled_deepslate_slab": "Geplaveide wrevelstenen plaat",
  "block.minecraft.cobbled_deepslate_stairs": "Geplaveide wrevelstenen trap",
  "block.minecraft.cobbled_deepslate_wall": "Geplaveide wrevelstenen muur",
  "block.minecraft.cobblestone": "Keisteen",
  "block.minecraft.cobblestone_slab": "Keistenen plaat",
  "block.minecraft.cobblestone_stairs": "Keistenen trap",
  "block.minecraft.cobblestone_wall": "Keistenen muur",
  "block.minecraft.cobweb": "Spinnenweb",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Opdrachtblok",
  "block.minecraft.comparator": "Redstonevergelijker",
  "block.minecraft.composter": "Composter",
  "block.minecraft.conduit": "Kracht van de zee",
  "block.minecraft.copper_bars": "Koperen tralies",
  "block.minecraft.copper_block": "Koperblok",
  "block.minecraft.copper_bulb": "Koperen lamp",
  "block.minecraft.copper_chain": "Koperen ketting",
  "block.minecraft.copper_chest": "Koperen kist",
  "block.minecraft.copper_door": "Koperen deur",
  "block.minecraft.copper_golem_statue": "Kopergolemstandbeeld",
  "block.minecraft.copper_grate": "Koperen rooster",
  "block.minecraft.copper_lantern": "Koperen lantaarn",
  "block.minecraft.copper_ore": "Kopererts",
  "block.minecraft.copper_torch": "Koperfakkel",
  "block.minecraft.copper_trapdoor": "Koperen valluik",
  "block.minecraft.copper_wall_torch": "Koperfakkel aan muur",
  "block.minecraft.cornflower": "Korenbloem",
  "block.minecraft.cracked_deepslate_bricks": "Gebarsten wrevelstenen blokstenen",
  "block.minecraft.cracked_deepslate_tiles": "Gebarsten wrevelstenen tegels",
  "block.minecraft.cracked_nether_bricks": "Gebarsten Netherbakstenen",
  "block.minecraft.cracked_polished_blackstone_bricks": "Gebarsten gepolijste zwartstenen blokstenen",
  "block.minecraft.cracked_stone_bricks": "Gebarsten blokstenen",
  "block.minecraft.crafter": "Vervaardigingsmachine",
  "block.minecraft.crafting_table": "Werkbank",
  "block.minecraft.creaking_heart": "Schorswakerhart",
  "block.minecraft.creeper_head": "Creeperhoofd",
  "block.minecraft.creeper_wall_head": "Creeperhoofd aan muur",
  "block.minecraft.crimson_button": "Helrode houten knop",
  "block.minecraft.crimson_door": "Helrode houten deur",
  "block.minecraft.crimson_fence": "Helrood houten hek",
  "block.minecraft.crimson_fence_gate": "Helrode houten poort",
  "block.minecraft.crimson_fungus": "Helrode zwam",
  "block.minecraft.crimson_hanging_sign": "Helrood houten hangbord",
  "block.minecraft.crimson_hyphae": "Helrode schimmeldraden",
  "block.minecraft.crimson_nylium": "Helrood nylium",
  "block.minecraft.crimson_planks": "Helrode houten planken",
  "block.minecraft.crimson_pressure_plate": "Helrode houten drukplaat",
  "block.minecraft.crimson_roots": "Helrode wortels",
  "block.minecraft.crimson_shelf": "Helrood houten schap",
  "block.minecraft.crimson_sign": "Helrood bord",
  "block.minecraft.crimson_slab": "Helrode houten plaat",
  "block.minecraft.crimson_stairs": "Helrode houten trap",
  "block.minecraft.crimson_stem": "Helrode stam",
  "block.minecraft.crimson_trapdoor": "Helrood houten valluik",
  "block.minecraft.crimson_wall_hanging_sign": "Helrood houten uithangbord",
  "block.minecraft.crimson_wall_sign": "Helrood bord aan muur",
  "block.minecraft.crying_obsidian": "Huilend obsidiaan",
  "block.minecraft.cut_copper": "Gesneden koperblok",
  "block.minecraft.cut_copper_slab": "Gesneden koperen plaat",
  "block.minecraft.cut_copper_stairs": "Gesneden koperen trap",
  "block.minecraft.cut_red_sandstone": "Gesneden rood zandsteen",
  "block.minecraft.cut_red_sandstone_slab": "Gesneden rode zandstenen plaat",
  "block.minecraft.cut_sandstone": "Gesneden zandsteen",
  "block.minecraft.cut_sandstone_slab": "Gesneden zandstenen plaat",
  "block.minecraft.cyan_banner": "Cyaan vlag",
  "block.minecraft.cyan_bed": "Cyaan bed",
  "block.minecraft.cyan_candle": "Turquoise kaars",
  "block.minecraft.cyan_candle_cake": "Taart met turquoise kaars",
  "block.minecraft.cyan_carpet": "Cyaan tapijt",
  "block.minecraft.cyan_concrete": "Cyaan beton",
  "block.minecraft.cyan_concrete_powder": "Cyaan cement",
  "block.minecraft.cyan_glazed_terracotta": "Cyaangeglazuurde terracotta",
  "block.minecraft.cyan_shulker_box": "Cyaan Shulkerdoos",
  "block.minecraft.cyan_stained_glass": "Cyaangekleurd glas",
  "block.minecraft.cyan_stained_glass_pane": "Cyaangekleurde glazen ruit",
  "block.minecraft.cyan_terracotta": "Cyaan terracotta",
  "block.minecraft.cyan_wool": "Cyaan wol",
  "block.minecraft.damaged_anvil": "Beschadigd aanvil",
  "block.minecraft.dandelion": "Paardenbloem",
  "block.minecraft.dark_oak_button": "Donkereiken knop",
  "block.minecraft.dark_oak_door": "Donkereiken deur",
  "block.minecraft.dark_oak_fence": "Donkereikenhouten hek",
  "block.minecraft.dark_oak_fence_gate": "Donkereikenhouten poort",
  "block.minecraft.dark_oak_hanging_sign": "Donkereikenhouten hangbord",
  "block.minecraft.dark_oak_leaves": "Donkereikenbladeren",
  "block.minecraft.dark_oak_log": "Donkereikenstam",
  "block.minecraft.dark_oak_planks": "Donkereiken planken",
  "block.minecraft.dark_oak_pressure_plate": "Donkereiken drukplaat",
  "block.minecraft.dark_oak_sapling": "Donkereikenkiemplant",
  "block.minecraft.dark_oak_shelf": "Donkereikenhouten plank",
  "block.minecraft.dark_oak_sign": "Donkereiken bord",
  "block.minecraft.dark_oak_slab": "Donkereiken plaat",
  "block.minecraft.dark_oak_stairs": "Donkereiken trap",
  "block.minecraft.dark_oak_trapdoor": "Donkereiken valluik",
  "block.minecraft.dark_oak_wall_hanging_sign": "Donkereikenhouten uithangbord",
  "block.minecraft.dark_oak_wall_sign": "Donkereiken bord aan muur",
  "block.minecraft.dark_oak_wood": "Donkereikenhout",
  "block.minecraft.dark_prismarine": "Donkerprismarien",
  "block.minecraft.dark_prismarine_slab": "Donkerprismarienplaat",
  "block.minecraft.dark_prismarine_stairs": "Donkerprismarientrap",
  "block.minecraft.daylight_detector": "Daglichtsensor",
  "block.minecraft.dead_brain_coral": "Dood hersenkoraal",
  "block.minecraft.dead_brain_coral_block": "Dood hersenkoraalblok",
  "block.minecraft.dead_brain_coral_fan": "Dode hersenkoraalwaaier",
  "block.minecraft.dead_brain_coral_wall_fan": "Dode hersenkoraalwaaier aan muur",
  "block.minecraft.dead_bubble_coral": "Dood blaaskoraal",
  "block.minecraft.dead_bubble_coral_block": "Dood blaaskoraalblok",
  "block.minecraft.dead_bubble_coral_fan": "Dode blaaskoraalwaaier",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dode blaaskoraalwaaier aan muur",
  "block.minecraft.dead_bush": "Dode struik",
  "block.minecraft.dead_fire_coral": "Dood brandkoraal",
  "block.minecraft.dead_fire_coral_block": "Dood brandkoraalblok",
  "block.minecraft.dead_fire_coral_fan": "Dode brandkoraalwaaier",
  "block.minecraft.dead_fire_coral_wall_fan": "Dode brandkoraalwaaier aan muur",
  "block.minecraft.dead_horn_coral": "Dood hoornkoraal",
  "block.minecraft.dead_horn_coral_block": "Dood hoornkoraalblok",
  "block.minecraft.dead_horn_coral_fan": "Dode hoornkoraalwaaier",
  "block.minecraft.dead_horn_coral_wall_fan": "Dode hoornkoraalwaaier aan muur",
  "block.minecraft.dead_tube_coral": "Dood buiskoraal",
  "block.minecraft.dead_tube_coral_block": "Dood buiskoraalblok",
  "block.minecraft.dead_tube_coral_fan": "Dode buiskoraalwaaier",
  "block.minecraft.dead_tube_coral_wall_fan": "Dode buiskoraalwaaier aan muur",
  "block.minecraft.decorated_pot": "Versierde pot",
  "block.minecraft.deepslate": "Wrevelsteen",
  "block.minecraft.deepslate_brick_slab": "Wrevelblokstenen plaat",
  "block.minecraft.deepslate_brick_stairs": "Wrevelblokstenen trap",
  "block.minecraft.deepslate_brick_wall": "Wrevelblokstenen muur",
  "block.minecraft.deepslate_bricks": "Wrevelblokstenen",
  "block.minecraft.deepslate_coal_ore": "Wrevelsteen-steenkoolerts",
  "block.minecraft.deepslate_copper_ore": "Wrevelsteenkopererts",
  "block.minecraft.deepslate_diamond_ore": "Wrevelsteendiamanterts",
  "block.minecraft.deepslate_emerald_ore": "Wrevelsteensmaragderts",
  "block.minecraft.deepslate_gold_ore": "Wrevelsteengouderts",
  "block.minecraft.deepslate_iron_ore": "Wrevelsteenijzererts",
  "block.minecraft.deepslate_lapis_ore": "Wrevelsteenlapislazuli-erts",
  "block.minecraft.deepslate_redstone_ore": "Wrevelsteenredstone-erts",
  "block.minecraft.deepslate_tile_slab": "Wrevelstenen tegelplaat",
  "block.minecraft.deepslate_tile_stairs": "Wrevelstenen tegeltrap",
  "block.minecraft.deepslate_tile_wall": "Wrevelstenen tegelmuur",
  "block.minecraft.deepslate_tiles": "Wrevelstenen tegels",
  "block.minecraft.detector_rail": "Detectiespoor",
  "block.minecraft.diamond_block": "Diamantblok",
  "block.minecraft.diamond_ore": "Diamanterts",
  "block.minecraft.diorite": "Dioriet",
  "block.minecraft.diorite_slab": "Diorietplaat",
  "block.minecraft.diorite_stairs": "Dioriettrap",
  "block.minecraft.diorite_wall": "Diorietenmuur",
  "block.minecraft.dirt": "Aarde",
  "block.minecraft.dirt_path": "Aardepad",
  "block.minecraft.dispenser": "Uitwerper",
  "block.minecraft.dragon_egg": "Drakenei",
  "block.minecraft.dragon_head": "Drakenhoofd",
  "block.minecraft.dragon_wall_head": "Drakenhoofd aan muur",
  "block.minecraft.dried_ghast": "Uitgedroogde Ghast",
  "block.minecraft.dried_kelp_block": "Gedroogd kelpblok",
  "block.minecraft.dripstone_block": "Druipsteenblok",
  "block.minecraft.dropper": "Dropper",
  "block.minecraft.emerald_block": "Smaragdblok",
  "block.minecraft.emerald_ore": "Smaragderts",
  "block.minecraft.enchanting_table": "Betoveringstafel",
  "block.minecraft.end_gateway": "Endtoegangsportaal",
  "block.minecraft.end_portal": "Endportaal",
  "block.minecraft.end_portal_frame": "Endportaalframe",
  "block.minecraft.end_rod": "Endstaf",
  "block.minecraft.end_stone": "Endsteen",
  "block.minecraft.end_stone_brick_slab": "Endblokstenen plaat",
  "block.minecraft.end_stone_brick_stairs": "Endblokstenen trap",
  "block.minecraft.end_stone_brick_wall": "Endblokstenen muur",
  "block.minecraft.end_stone_bricks": "Endblokstenen",
  "block.minecraft.ender_chest": "Enderkist",
  "block.minecraft.exposed_chiseled_copper": "Blootgesteld bewerkt koperblok",
  "block.minecraft.exposed_copper": "Vrijliggend koperblok",
  "block.minecraft.exposed_copper_bars": "Blootgestelde koperen tralies",
  "block.minecraft.exposed_copper_bulb": "Blootgestelde koperen lamp",
  "block.minecraft.exposed_copper_chain": "Blootgestelde koperen ketting",
  "block.minecraft.exposed_copper_chest": "Blootgestelde koperen kist",
  "block.minecraft.exposed_copper_door": "Blootgestelde koperen deur",
  "block.minecraft.exposed_copper_golem_statue": "Blootgesteld kopergolemstandbeeld",
  "block.minecraft.exposed_copper_grate": "Blootgesteld koperen rooster",
  "block.minecraft.exposed_copper_lantern": "Blootgestelde koperen lantaarn",
  "block.minecraft.exposed_copper_trapdoor": "Blootgesteld koperen valluik",
  "block.minecraft.exposed_cut_copper": "Vrijliggend gesneden koperblok",
  "block.minecraft.exposed_cut_copper_slab": "Vrijliggende gesneden koperen plaat",
  "block.minecraft.exposed_cut_copper_stairs": "Vrijliggende gesneden koperen trap",
  "block.minecraft.exposed_lightning_rod": "Blootgestelde bliksemafleider",
  "block.minecraft.farmland": "Akkerland",
  "block.minecraft.fern": "Varen",
  "block.minecraft.fire": "Vuur",
  "block.minecraft.fire_coral": "Brandkoraal",
  "block.minecraft.fire_coral_block": "Brandkoraalblok",
  "block.minecraft.fire_coral_fan": "Brandkoraalwaaier",
  "block.minecraft.fire_coral_wall_fan": "Brandkoraalwaaier aan muur",
  "block.minecraft.firefly_bush": "Vuurvliegstruik",
  "block.minecraft.fletching_table": "Pijlenmakerstafel",
  "block.minecraft.flower_pot": "Bloempot",
  "block.minecraft.flowering_azalea": "Bloeiende azalea",
  "block.minecraft.flowering_azalea_leaves": "Bloeiende azaleabladeren",
  "block.minecraft.frogspawn": "Kikkerdril",
  "block.minecraft.frosted_ice": "Bevroren ijs",
  "block.minecraft.furnace": "Oven",
  "block.minecraft.gilded_blackstone": "Verguld zwartsteen",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glazen ruit",
  "block.minecraft.glow_lichen": "Gloeiend korstmos",
  "block.minecraft.glowstone": "Gloeisteen",
  "block.minecraft.gold_block": "Goudblok",
  "block.minecraft.gold_ore": "Gouderts",
  "block.minecraft.golden_dandelion": "Gouden paardenbloem",
  "block.minecraft.granite": "Graniet",
  "block.minecraft.granite_slab": "Granietplaat",
  "block.minecraft.granite_stairs": "Graniettrap",
  "block.minecraft.granite_wall": "Granieten muur",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblok",
  "block.minecraft.gravel": "Grind",
  "block.minecraft.gray_banner": "Grijze vlag",
  "block.minecraft.gray_bed": "Grijs bed",
  "block.minecraft.gray_candle": "Grijze kaars",
  "block.minecraft.gray_candle_cake": "Taart met grijze kaars",
  "block.minecraft.gray_carpet": "Grijs tapijt",
  "block.minecraft.gray_concrete": "Grijs beton",
  "block.minecraft.gray_concrete_powder": "Grijs cement",
  "block.minecraft.gray_glazed_terracotta": "Grijsgeglazuurde terracotta",
  "block.minecraft.gray_shulker_box": "Grijze Shulkerdoos",
  "block.minecraft.gray_stained_glass": "Grijsgekleurd glas",
  "block.minecraft.gray_stained_glass_pane": "Grijsgekleurde glazen ruit",
  "block.minecraft.gray_terracotta": "Grijs terracotta",
  "block.minecraft.gray_wool": "Grijze wol",
  "block.minecraft.green_banner": "Groene vlag",
  "block.minecraft.green_bed": "Groen bed",
  "block.minecraft.green_candle": "Groene kaars",
  "block.minecraft.green_candle_cake": "Taart met groene kaars",
  "block.minecraft.green_carpet": "Groen tapijt",
  "block.minecraft.green_concrete": "Groen beton",
  "block.minecraft.green_concrete_powder": "Groen cement",
  "block.minecraft.green_glazed_terracotta": "Groengeglazuurde terracotta",
  "block.minecraft.green_shulker_box": "Groene Shulkerdoos",
  "block.minecraft.green_stained_glass": "Groengekleurd glas",
  "block.minecraft.green_stained_glass_pane": "Groengekleurde glazen ruit",
  "block.minecraft.green_terracotta": "Groen terracotta",
  "block.minecraft.green_wool": "Groene wol",
  "block.minecraft.grindstone": "Slijpsteen",
  "block.minecraft.hanging_roots": "Hangende wortels",
  "block.minecraft.hay_block": "Hooibaal",
  "block.minecraft.heavy_core": "Zware kern",
  "block.minecraft.heavy_weighted_pressure_plate": "Zware drukgevoelige plaat",
  "block.minecraft.honey_block": "Honingblok",
  "block.minecraft.honeycomb_block": "Honingraatblok",
  "block.minecraft.hopper": "Trechter",
  "block.minecraft.horn_coral": "Hoornkoraal",
  "block.minecraft.horn_coral_block": "Hoornkoraalblok",
  "block.minecraft.horn_coral_fan": "Hoornkoraalwaaier",
  "block.minecraft.horn_coral_wall_fan": "Hoornkoraalwaaier aan muur",
  "block.minecraft.ice": "IJs",
  "block.minecraft.infested_chiseled_stone_bricks": "Geïnfecteerde gebeitelde blokstenen",
  "block.minecraft.infested_cobblestone": "Geïnfecteerde keisteen",
  "block.minecraft.infested_cracked_stone_bricks": "Geïnfecteerde gebarsten blokstenen",
  "block.minecraft.infested_deepslate": "Geïnfecteerd wrevelsteen",
  "block.minecraft.infested_mossy_stone_bricks": "Geïnfecteerde mossige blokstenen",
  "block.minecraft.infested_stone": "Geïnfecteerde steen",
  "block.minecraft.infested_stone_bricks": "Geïnfecteerde blokstenen",
  "block.minecraft.iron_bars": "Tralies",
  "block.minecraft.iron_block": "Ijzerblok",
  "block.minecraft.iron_chain": "IJzeren ketting",
  "block.minecraft.iron_door": "IJzeren deur",
  "block.minecraft.iron_ore": "IJzererts",
  "block.minecraft.iron_trapdoor": "IJzeren valluik",
  "block.minecraft.jack_o_lantern": "Jack o'Lantern",
  "block.minecraft.jigsaw": "Puzzelblok",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Oerwoud knop",
  "block.minecraft.jungle_door": "Oerwoud deur",
  "block.minecraft.jungle_fence": "Oerwoudhouten hek",
  "block.minecraft.jungle_fence_gate": "Oerwoudhouten poort",
  "block.minecraft.jungle_hanging_sign": "Oerwoudhouten hangbord",
  "block.minecraft.jungle_leaves": "Oerwoudbladeren",
  "block.minecraft.jungle_log": "Oerwoudstam",
  "block.minecraft.jungle_planks": "Oerwoud planken",
  "block.minecraft.jungle_pressure_plate": "Oerwoud drukplaat",
  "block.minecraft.jungle_sapling": "Oerwoudkiemplant",
  "block.minecraft.jungle_shelf": "Oerwoudhouten plank",
  "block.minecraft.jungle_sign": "Oerwoud bord",
  "block.minecraft.jungle_slab": "Oerwoud plaat",
  "block.minecraft.jungle_stairs": "Oerwoud trap",
  "block.minecraft.jungle_trapdoor": "Oerwoud valluik",
  "block.minecraft.jungle_wall_hanging_sign": "Oerwoudhouten uithangbord",
  "block.minecraft.jungle_wall_sign": "Oerwoud bord aan muur",
  "block.minecraft.jungle_wood": "Oerwoudhout",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelpplant",
  "block.minecraft.ladder": "Ladder",
  "block.minecraft.lantern": "Lantaarn",
  "block.minecraft.lapis_block": "Lapislazuliblok",
  "block.minecraft.lapis_ore": "Lapis lazuli-erts",
  "block.minecraft.large_amethyst_bud": "Grote amethistknop",
  "block.minecraft.large_fern": "Grote varen",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Ketel met lava",
  "block.minecraft.leaf_litter": "Bladstrooisel",
  "block.minecraft.lectern": "Lezenaar",
  "block.minecraft.lever": "Hendel",
  "block.minecraft.light": "Licht",
  "block.minecraft.light_blue_banner": "Lichtblauwe vlag",
  "block.minecraft.light_blue_bed": "Lichtblauw bed",
  "block.minecraft.light_blue_candle": "Lichtblauwe kaars",
  "block.minecraft.light_blue_candle_cake": "Taart met licht blauwe kaars",
  "block.minecraft.light_blue_carpet": "Lichtblauw tapijt",
  "block.minecraft.light_blue_concrete": "Lichtblauw beton",
  "block.minecraft.light_blue_concrete_powder": "Lichtblauw cement",
  "block.minecraft.light_blue_glazed_terracotta": "Lichtblauwgeglazuurde terracotta",
  "block.minecraft.light_blue_shulker_box": "Lichtblauwe Shulkerdoos",
  "block.minecraft.light_blue_stained_glass": "Lichtblauwgekleurd glas",
  "block.minecraft.light_blue_stained_glass_pane": "Lichtblauwgekleurde glazen ruit",
  "block.minecraft.light_blue_terracotta": "Lichtblauw terracotta",
  "block.minecraft.light_blue_wool": "Lichtblauwe wol",
  "block.minecraft.light_gray_banner": "Lichtgrijze vlag",
  "block.minecraft.light_gray_bed": "Lichtgrijs bed",
  "block.minecraft.light_gray_candle": "Lichtgrijze kaars",
  "block.minecraft.light_gray_candle_cake": "Taart met lichtgrijze kaars",
  "block.minecraft.light_gray_carpet": "Lichtgrijs tapijt",
  "block.minecraft.light_gray_concrete": "Lichtgrijs beton",
  "block.minecraft.light_gray_concrete_powder": "Lichtgrijs cement",
  "block.minecraft.light_gray_glazed_terracotta": "Lichtgrijsgeglazuurde terracotta",
  "block.minecraft.light_gray_shulker_box": "Lichtgrijze Shulkerdoos",
  "block.minecraft.light_gray_stained_glass": "Lichtgrijsgekleurd glas",
  "block.minecraft.light_gray_stained_glass_pane": "Lichtgrijsgekleurde glazen ruit",
  "block.minecraft.light_gray_terracotta": "Lichtgrijs terracotta",
  "block.minecraft.light_gray_wool": "Lichtgrijze wol",
  "block.minecraft.light_weighted_pressure_plate": "Lichte drukgevoelige plaat",
  "block.minecraft.lightning_rod": "Bliksemafleider",
  "block.minecraft.lilac": "Sering",
  "block.minecraft.lily_of_the_valley": "Lelietjes-der-Dalen",
  "block.minecraft.lily_pad": "Waterlelie",
  "block.minecraft.lime_banner": "Limoengroene vlag",
  "block.minecraft.lime_bed": "Limoengroen bed",
  "block.minecraft.lime_candle": "Limoengroene kaars",
  "block.minecraft.lime_candle_cake": "Taart met limoengroene kaars",
  "block.minecraft.lime_carpet": "Limoengroen tapijt",
  "block.minecraft.lime_concrete": "Limoengroen beton",
  "block.minecraft.lime_concrete_powder": "Limoengroen cement",
  "block.minecraft.lime_glazed_terracotta": "Limoengroengeglazuurde terracotta",
  "block.minecraft.lime_shulker_box": "Limoengroene shulkerdoos",
  "block.minecraft.lime_stained_glass": "Limoengroengekleurd glas",
  "block.minecraft.lime_stained_glass_pane": "Limoengroengekleurde glazen ruit",
  "block.minecraft.lime_terracotta": "Limoengroene terracotta",
  "block.minecraft.lime_wool": "Limoengroen wol",
  "block.minecraft.lodestone": "Zeilsteen",
  "block.minecraft.loom": "Weefgetouw",
  "block.minecraft.magenta_banner": "Magenta vlag",
  "block.minecraft.magenta_bed": "Magenta bed",
  "block.minecraft.magenta_candle": "Magenta kaars",
  "block.minecraft.magenta_candle_cake": "Taart met magenta Kaars",
  "block.minecraft.magenta_carpet": "Magenta tapijt",
  "block.minecraft.magenta_concrete": "Magenta beton",
  "block.minecraft.magenta_concrete_powder": "Magenta cement",
  "block.minecraft.magenta_glazed_terracotta": "Magentageglazuurde terracotta",
  "block.minecraft.magenta_shulker_box": "Magenta Shulkerdoos",
  "block.minecraft.magenta_stained_glass": "Magentagekleurd glas",
  "block.minecraft.magenta_stained_glass_pane": "Magentagekleurde glazen ruit",
  "block.minecraft.magenta_terracotta": "Magenta terracotta",
  "block.minecraft.magenta_wool": "Magenta wol",
  "block.minecraft.magma_block": "Magmablok",
  "block.minecraft.mangrove_button": "Mangrovehouten knop",
  "block.minecraft.mangrove_door": "Mangrovehouten deur",
  "block.minecraft.mangrove_fence": "Mangrovehouten hek",
  "block.minecraft.mangrove_fence_gate": "Mangrovehouten poort",
  "block.minecraft.mangrove_hanging_sign": "Mangrovehouten hangbord",
  "block.minecraft.mangrove_leaves": "Mangrovebladeren",
  "block.minecraft.mangrove_log": "Mangrovestam",
  "block.minecraft.mangrove_planks": "Mangrovehouten planken",
  "block.minecraft.mangrove_pressure_plate": "Mangrovehouten drukplaat",
  "block.minecraft.mangrove_propagule": "Mangrovebroedknop",
  "block.minecraft.mangrove_roots": "Mangrovewortels",
  "block.minecraft.mangrove_shelf": "Mangrovehouten plank",
  "block.minecraft.mangrove_sign": "Mangrovehouten bord",
  "block.minecraft.mangrove_slab": "Mangrovehouten plaat",
  "block.minecraft.mangrove_stairs": "Mangrovehouten trap",
  "block.minecraft.mangrove_trapdoor": "Mangrovehouten valluik",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovehouten uithangbord",
  "block.minecraft.mangrove_wall_sign": "Mangrovehouten bord aan muur",
  "block.minecraft.mangrove_wood": "Mangrovehout",
  "block.minecraft.medium_amethyst_bud": "Middelgrote amethistknop",
  "block.minecraft.melon": "Meloen",
  "block.minecraft.melon_stem": "Meloenstam",
  "block.minecraft.moss_block": "Mosblok",
  "block.minecraft.moss_carpet": "Mostapijt",
  "block.minecraft.mossy_cobblestone": "Mossige keisteen",
  "block.minecraft.mossy_cobblestone_slab": "Mossige keistenen plaat",
  "block.minecraft.mossy_cobblestone_stairs": "Mossige keistenen trap",
  "block.minecraft.mossy_cobblestone_wall": "Mossige keistenen muur",
  "block.minecraft.mossy_stone_brick_slab": "Mossige blokstenen plaat",
  "block.minecraft.mossy_stone_brick_stairs": "Mossige blokstenen trap",
  "block.minecraft.mossy_stone_brick_wall": "Mossige blokstenen muur",
  "block.minecraft.mossy_stone_bricks": "Mossige blokstenen",
  "block.minecraft.moving_piston": "Bewegende zuiger",
  "block.minecraft.mud": "Modder",
  "block.minecraft.mud_brick_slab": "Modderstenen plaat",
  "block.minecraft.mud_brick_stairs": "Modderstenen trap",
  "block.minecraft.mud_brick_wall": "Modderstenen muur",
  "block.minecraft.mud_bricks": "Modderstenen",
  "block.minecraft.muddy_mangrove_roots": "Modderige mangrovewortels",
  "block.minecraft.mushroom_stem": "Paddenstoelenstam",
  "block.minecraft.mycelium": "Zwamvlok",
  "block.minecraft.nether_brick_fence": "Netherbakstenen hek",
  "block.minecraft.nether_brick_slab": "Netherbakstenen plaat",
  "block.minecraft.nether_brick_stairs": "Netherbakstenen trap",
  "block.minecraft.nether_brick_wall": "Netherbakstenen muur",
  "block.minecraft.nether_bricks": "Netherbakstenen",
  "block.minecraft.nether_gold_ore": "Nethergouderts",
  "block.minecraft.nether_portal": "Netherportaal",
  "block.minecraft.nether_quartz_ore": "Netherkwartserts",
  "block.minecraft.nether_sprouts": "Netherscheuten",
  "block.minecraft.nether_wart": "Netherkruid",
  "block.minecraft.nether_wart_block": "Netherkruidblok",
  "block.minecraft.netherite_block": "Netherietblok",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nootblok",
  "block.minecraft.oak_button": "Eiken knop",
  "block.minecraft.oak_door": "Eiken deur",
  "block.minecraft.oak_fence": "Eikenhouten hek",
  "block.minecraft.oak_fence_gate": "Eikenhouten poort",
  "block.minecraft.oak_hanging_sign": "Eikenhouten hangbord",
  "block.minecraft.oak_leaves": "Eikenbladeren",
  "block.minecraft.oak_log": "Eikenstam",
  "block.minecraft.oak_planks": "Eiken planken",
  "block.minecraft.oak_pressure_plate": "Eiken drukplaat",
  "block.minecraft.oak_sapling": "Eikenkiemplant",
  "block.minecraft.oak_shelf": "Eikenhouten plank",
  "block.minecraft.oak_sign": "Eiken bord",
  "block.minecraft.oak_slab": "Eiken plaat",
  "block.minecraft.oak_stairs": "Eiken trap",
  "block.minecraft.oak_trapdoor": "Eiken valluik",
  "block.minecraft.oak_wall_hanging_sign": "Eikenhouten uithangbord",
  "block.minecraft.oak_wall_sign": "Eiken bord aan muur",
  "block.minecraft.oak_wood": "Eikenhout",
  "block.minecraft.observer": "Observeerder",
  "block.minecraft.obsidian": "Obsidiaan",
  "block.minecraft.ochre_froglight": "Okergeel kikkerlicht",
  "block.minecraft.ominous_banner": "Dreigende vlag",
  "block.minecraft.open_eyeblossom": "Geopende gluurbloesem",
  "block.minecraft.orange_banner": "Oranje vlag",
  "block.minecraft.orange_bed": "Oranje bed",
  "block.minecraft.orange_candle": "Oranje kaars",
  "block.minecraft.orange_candle_cake": "Taart met oranje kaars",
  "block.minecraft.orange_carpet": "Oranje tapijt",
  "block.minecraft.orange_concrete": "Oranje beton",
  "block.minecraft.orange_concrete_powder": "Oranje cement",
  "block.minecraft.orange_glazed_terracotta": "Oranjegeglazuurde terracotta",
  "block.minecraft.orange_shulker_box": "Oranje Shulkerdoos",
  "block.minecraft.orange_stained_glass": "Oranjegekleurd glas",
  "block.minecraft.orange_stained_glass_pane": "Oranjegekleurde glazen ruit",
  "block.minecraft.orange_terracotta": "Oranje terracotta",
  "block.minecraft.orange_tulip": "Oranje tulp",
  "block.minecraft.orange_wool": "Oranje wol",
  "block.minecraft.oxeye_daisy": "Madeliefje",
  "block.minecraft.oxidized_chiseled_copper": "Geoxideerd bewerkt koperblok",
  "block.minecraft.oxidized_copper": "Geoxideerd koperblok",
  "block.minecraft.oxidized_copper_bars": "Geoxideerde koperen tralies",
  "block.minecraft.oxidized_copper_bulb": "Geoxideerde koperen lamp",
  "block.minecraft.oxidized_copper_chain": "Geoxideerde koperen ketting",
  "block.minecraft.oxidized_copper_chest": "Geoxideerde koperen kist",
  "block.minecraft.oxidized_copper_door": "Geoxideerde koperen deur",
  "block.minecraft.oxidized_copper_golem_statue": "Geoxideerd kopergolemstandbeeld",
  "block.minecraft.oxidized_copper_grate": "Geoxideerd koperen rooster",
  "block.minecraft.oxidized_copper_lantern": "Geoxideerde koperen lantaarn",
  "block.minecraft.oxidized_copper_trapdoor": "Geoxideerd koperen valluik",
  "block.minecraft.oxidized_cut_copper": "Geoxideerd gesneden koperblok",
  "block.minecraft.oxidized_cut_copper_slab": "Geoxideerde gesneden koperen plaat",
  "block.minecraft.oxidized_cut_copper_stairs": "Geoxideerde gesneden koperen trap",
  "block.minecraft.oxidized_lightning_rod": "Geoxideerde bliksemafleider",
  "block.minecraft.packed_ice": "Pakijs",
  "block.minecraft.packed_mud": "Pakmodder",
  "block.minecraft.pale_hanging_moss": "Bleek Hangend Mos",
  "block.minecraft.pale_moss_block": "Bleek Mosblok",
  "block.minecraft.pale_moss_carpet": "Bleek Mostapijt",
  "block.minecraft.pale_oak_button": "Bleke Eikenhouten Knop",
  "block.minecraft.pale_oak_door": "Bleke Eikenhouten Deur",
  "block.minecraft.pale_oak_fence": "Bleek Eikenhouten Hek",
  "block.minecraft.pale_oak_fence_gate": "Bleke Eikenhouten Poort",
  "block.minecraft.pale_oak_hanging_sign": "Bleek Eikenhouten Hangbord",
  "block.minecraft.pale_oak_leaves": "Bleke Eikenbladeren",
  "block.minecraft.pale_oak_log": "Bleke Eikenstam",
  "block.minecraft.pale_oak_planks": "Bleke Eikenhouten Planken",
  "block.minecraft.pale_oak_pressure_plate": "Bleke eiken drukplaat",
  "block.minecraft.pale_oak_sapling": "Jonge bleke eiken boom",
  "block.minecraft.pale_oak_shelf": "Bleek eikenhouten plank",
  "block.minecraft.pale_oak_sign": "Bleke eiken bord",
  "block.minecraft.pale_oak_slab": "Bleke eiken plaat",
  "block.minecraft.pale_oak_stairs": "Bleke eiken trap",
  "block.minecraft.pale_oak_trapdoor": "Bleke eiken valluik",
  "block.minecraft.pale_oak_wall_hanging_sign": "Bleke eiken muur hangend bord",
  "block.minecraft.pale_oak_wall_sign": "Bleek eiken bord aan muur",
  "block.minecraft.pale_oak_wood": "Bleke Eikenhouten Schors",
  "block.minecraft.pearlescent_froglight": "Parelkleurig kikkerlicht",
  "block.minecraft.peony": "Pioenroos",
  "block.minecraft.petrified_oak_slab": "Versteende eiken plaat",
  "block.minecraft.piglin_head": "Piglinhoofd",
  "block.minecraft.piglin_wall_head": "Piglinhoofd aan muur",
  "block.minecraft.pink_banner": "Roze vlag",
  "block.minecraft.pink_bed": "Roze bed",
  "block.minecraft.pink_candle": "Roze kaars",
  "block.minecraft.pink_candle_cake": "Taart met roze kaars",
  "block.minecraft.pink_carpet": "Roze tapijt",
  "block.minecraft.pink_concrete": "Roze beton",
  "block.minecraft.pink_concrete_powder": "Roze cement",
  "block.minecraft.pink_glazed_terracotta": "Rozegeglazuurde terracotta",
  "block.minecraft.pink_petals": "Roze bloemblaadjes",
  "block.minecraft.pink_shulker_box": "Roze shulkerdoos",
  "block.minecraft.pink_stained_glass": "Rozegekleurd glas",
  "block.minecraft.pink_stained_glass_pane": "Rozegekleurde glazen ruit",
  "block.minecraft.pink_terracotta": "Roze terracotta",
  "block.minecraft.pink_tulip": "Roze tulp",
  "block.minecraft.pink_wool": "Roze wol",
  "block.minecraft.piston": "Zuiger",
  "block.minecraft.piston_head": "Zuigerhoofd",
  "block.minecraft.pitcher_crop": "Bekerplantgewas",
  "block.minecraft.pitcher_plant": "Bekerplant",
  "block.minecraft.player_head": "Speler hoofd",
  "block.minecraft.player_head.named": "Hoofd van %s",
  "block.minecraft.player_wall_head": "Spelerhoofd aan muur",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Puntige druipsteen",
  "block.minecraft.polished_andesite": "Gepolijst andesiet",
  "block.minecraft.polished_andesite_slab": "Gepolijst andesietplaat",
  "block.minecraft.polished_andesite_stairs": "Gepolijst andesiettrap",
  "block.minecraft.polished_basalt": "Gepolijst basalt",
  "block.minecraft.polished_blackstone": "Gepolijst zwartsteen",
  "block.minecraft.polished_blackstone_brick_slab": "Gepolijste zwartstenen blokstenen plaat",
  "block.minecraft.polished_blackstone_brick_stairs": "Gepolijste zwartstenen blokstenen trap",
  "block.minecraft.polished_blackstone_brick_wall": "Gepolijste zwartstenen blokstenen muur",
  "block.minecraft.polished_blackstone_bricks": "Gepolijste zwartstenen blokstenen",
  "block.minecraft.polished_blackstone_button": "Gepolijste zwartstenen knop",
  "block.minecraft.polished_blackstone_pressure_plate": "Gepolijste zwartstenen drukplaat",
  "block.minecraft.polished_blackstone_slab": "Gepolijste zwartstenen plaat",
  "block.minecraft.polished_blackstone_stairs": "Gepolijste zwartstenen trap",
  "block.minecraft.polished_blackstone_wall": "Gepolijste zwartstenen muur",
  "block.minecraft.polished_deepslate": "Gepolijst wrevelsteen",
  "block.minecraft.polished_deepslate_slab": "Gepolijste wrevelstenen plaat",
  "block.minecraft.polished_deepslate_stairs": "Gepolijste wrevelstenen trap",
  "block.minecraft.polished_deepslate_wall": "Gepolijste wrevelstenen muur",
  "block.minecraft.polished_diorite": "Gepolijst dioriet",
  "block.minecraft.polished_diorite_slab": "Gepolijste diorietplaat",
  "block.minecraft.polished_diorite_stairs": "Gepolijste dioriettrap",
  "block.minecraft.polished_granite": "Gepolijst graniet",
  "block.minecraft.polished_granite_slab": "Gepolijste granietplaat",
  "block.minecraft.polished_granite_stairs": "Gepolijste granieten trap",
  "block.minecraft.polished_tuff": "Gepolijst tufsteen",
  "block.minecraft.polished_tuff_slab": "Gepolijste tufstenen plaat",
  "block.minecraft.polished_tuff_stairs": "Gepolijste tufstenen trap",
  "block.minecraft.polished_tuff_wall": "Gepolijste tufstenen muur",
  "block.minecraft.poppy": "Klaproos",
  "block.minecraft.potatoes": "Patatten",
  "block.minecraft.potted_acacia_sapling": "Acaciakiem in een pot",
  "block.minecraft.potted_allium": "Look in een pot",
  "block.minecraft.potted_azalea_bush": "Opgepotte azalea",
  "block.minecraft.potted_azure_bluet": "Porseleinsterretje in een pot",
  "block.minecraft.potted_bamboo": "Bamboe in een pot",
  "block.minecraft.potted_birch_sapling": "Berkenkiem in een pot",
  "block.minecraft.potted_blue_orchid": "Blauwe orchidee in een pot",
  "block.minecraft.potted_brown_mushroom": "Bruine paddenstoel in een pot",
  "block.minecraft.potted_cactus": "Cactus in een pot",
  "block.minecraft.potted_cherry_sapling": "Opgepotte kersenzaailing",
  "block.minecraft.potted_closed_eyeblossom": "Geplante gesloten gluutbloesem",
  "block.minecraft.potted_cornflower": "Korenbloem in een pot",
  "block.minecraft.potted_crimson_fungus": "Opgepotte helrode zwam",
  "block.minecraft.potted_crimson_roots": "Opgepotte helrode wortels",
  "block.minecraft.potted_dandelion": "Paardenbloem in een pot",
  "block.minecraft.potted_dark_oak_sapling": "Donkereikenkiem in een pot",
  "block.minecraft.potted_dead_bush": "Dode struik in een pot",
  "block.minecraft.potted_fern": "Varens in een pot",
  "block.minecraft.potted_flowering_azalea_bush": "Opgepotte bloeiende azalea",
  "block.minecraft.potted_golden_dandelion": "Gouden paardenbloem in een pot",
  "block.minecraft.potted_jungle_sapling": "Oerwoudkiem in een pot",
  "block.minecraft.potted_lily_of_the_valley": "Lelietjes-der-Dalen in een pot",
  "block.minecraft.potted_mangrove_propagule": "Opgepotte mangrovebroedknop",
  "block.minecraft.potted_oak_sapling": "Eikenkiem in een pot",
  "block.minecraft.potted_open_eyeblossom": "Opgepotte geopende gluurbloesem",
  "block.minecraft.potted_orange_tulip": "Oranje tulp in een pot",
  "block.minecraft.potted_oxeye_daisy": "Madeliefje in een pot",
  "block.minecraft.potted_pale_oak_sapling": "Geplante jonge bleke eiken boom",
  "block.minecraft.potted_pink_tulip": "Roze tulp in een pot",
  "block.minecraft.potted_poppy": "Klaproos in een pot",
  "block.minecraft.potted_red_mushroom": "Rode paddenstoel in een pot",
  "block.minecraft.potted_red_tulip": "Rode tulp in een pot",
  "block.minecraft.potted_spruce_sapling": "Sparrenkiem in een pot",
  "block.minecraft.potted_torchflower": "Opgepotte fakkelbloem",
  "block.minecraft.potted_warped_fungus": "Opgepotte spookachtige zwam",
  "block.minecraft.potted_warped_roots": "Opgepotte spookachtige wortels",
  "block.minecraft.potted_white_tulip": "Witte tulp in een pot",
  "block.minecraft.potted_wither_rose": "Witherroos in een pot",
  "block.minecraft.powder_snow": "Poedersneeuw",
  "block.minecraft.powder_snow_cauldron": "Ketel met poedersneeuw",
  "block.minecraft.powered_rail": "Aandrijfspoor",
  "block.minecraft.prismarine": "Prismarien",
  "block.minecraft.prismarine_brick_slab": "Prismarienblokstenen plaat",
  "block.minecraft.prismarine_brick_stairs": "Prismarienblokstenen trap",
  "block.minecraft.prismarine_bricks": "Prismarienblokstenen",
  "block.minecraft.prismarine_slab": "Prismarienplaat",
  "block.minecraft.prismarine_stairs": "Prismarientrap",
  "block.minecraft.prismarine_wall": "Prismarienmuur",
  "block.minecraft.pumpkin": "Pompoen",
  "block.minecraft.pumpkin_stem": "Pompoenstam",
  "block.minecraft.purple_banner": "Paarse vlag",
  "block.minecraft.purple_bed": "Paars bed",
  "block.minecraft.purple_candle": "Paarse kaars",
  "block.minecraft.purple_candle_cake": "Taart met paarse kaars",
  "block.minecraft.purple_carpet": "Paars tapijt",
  "block.minecraft.purple_concrete": "Paars beton",
  "block.minecraft.purple_concrete_powder": "Paars cement",
  "block.minecraft.purple_glazed_terracotta": "Paarsgeglazuurde terracotta",
  "block.minecraft.purple_shulker_box": "Paarse Shulkerdoos",
  "block.minecraft.purple_stained_glass": "Paarsgekleurd glas",
  "block.minecraft.purple_stained_glass_pane": "Paarsgekleurde glazen ruit",
  "block.minecraft.purple_terracotta": "Paars terracotta",
  "block.minecraft.purple_wool": "Paarse wol",
  "block.minecraft.purpur_block": "Purpurblok",
  "block.minecraft.purpur_pillar": "Purpurpilaar",
  "block.minecraft.purpur_slab": "Purpurplaat",
  "block.minecraft.purpur_stairs": "Purpurtrap",
  "block.minecraft.quartz_block": "Kwartsblok",
  "block.minecraft.quartz_bricks": "Kwartsblokstenen",
  "block.minecraft.quartz_pillar": "Kwartspilaar",
  "block.minecraft.quartz_slab": "Kwartsplaat",
  "block.minecraft.quartz_stairs": "Kwartstrap",
  "block.minecraft.rail": "Spoor",
  "block.minecraft.raw_copper_block": "Ruw koperblok",
  "block.minecraft.raw_gold_block": "Ruw goudblok",
  "block.minecraft.raw_iron_block": "Ruw ijzerblok",
  "block.minecraft.red_banner": "Rode vlag",
  "block.minecraft.red_bed": "Rood bed",
  "block.minecraft.red_candle": "Rode kaars",
  "block.minecraft.red_candle_cake": "Taart met rode kaars",
  "block.minecraft.red_carpet": "Rood tapijt",
  "block.minecraft.red_concrete": "Rood beton",
  "block.minecraft.red_concrete_powder": "Rood cement",
  "block.minecraft.red_glazed_terracotta": "Roodgeglazuurde terracotta",
  "block.minecraft.red_mushroom": "Rode paddenstoel",
  "block.minecraft.red_mushroom_block": "Rood paddenstoelenblok",
  "block.minecraft.red_nether_brick_slab": "Rode Netherbakstenen plaat",
  "block.minecraft.red_nether_brick_stairs": "Rode Netherbakstenen trap",
  "block.minecraft.red_nether_brick_wall": "Rode netherbakstenen muur",
  "block.minecraft.red_nether_bricks": "Rode Netherbakstenen",
  "block.minecraft.red_sand": "Rode zand",
  "block.minecraft.red_sandstone": "Rood zandsteen",
  "block.minecraft.red_sandstone_slab": "Rode zandstenen plaat",
  "block.minecraft.red_sandstone_stairs": "Rode zandstenen trap",
  "block.minecraft.red_sandstone_wall": "Rode zandstenen muur",
  "block.minecraft.red_shulker_box": "Rode Shulkerdoos",
  "block.minecraft.red_stained_glass": "Roodgekleurd glas",
  "block.minecraft.red_stained_glass_pane": "Roodgekleurde glazen ruit",
  "block.minecraft.red_terracotta": "Rood terracotta",
  "block.minecraft.red_tulip": "Rode tulp",
  "block.minecraft.red_wool": "Rode wol",
  "block.minecraft.redstone_block": "Redstoneblok",
  "block.minecraft.redstone_lamp": "Redstonelamp",
  "block.minecraft.redstone_ore": "Redstone erts",
  "block.minecraft.redstone_torch": "Redstonefakkel",
  "block.minecraft.redstone_wall_torch": "Redstonefakkel aan muur",
  "block.minecraft.redstone_wire": "Redstonedraad",
  "block.minecraft.reinforced_deepslate": "Gewapend wrevelsteen",
  "block.minecraft.repeater": "Redstoneversterker",
  "block.minecraft.repeating_command_block": "Herhalend opdrachtblok",
  "block.minecraft.resin_block": "Harsblok",
  "block.minecraft.resin_brick_slab": "Harsbakstenen plaat",
  "block.minecraft.resin_brick_stairs": "Harsbakstenen trap",
  "block.minecraft.resin_brick_wall": "Harsbakstenen muur",
  "block.minecraft.resin_bricks": "Harsbakstenen",
  "block.minecraft.resin_clump": "Harsdruppel",
  "block.minecraft.respawn_anchor": "Respawnanker",
  "block.minecraft.rooted_dirt": "Gewortelde aarde",
  "block.minecraft.rose_bush": "Rozenstruik",
  "block.minecraft.sand": "Zand",
  "block.minecraft.sandstone": "Zandsteen",
  "block.minecraft.sandstone_slab": "Zandstenen plaat",
  "block.minecraft.sandstone_stairs": "Zandstenen trap",
  "block.minecraft.sandstone_wall": "Zandstenen muur",
  "block.minecraft.scaffolding": "Stelling",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkkatalysator",
  "block.minecraft.sculk_sensor": "Sculksensor",
  "block.minecraft.sculk_shrieker": "Sculkkrijser",
  "block.minecraft.sculk_vein": "Sculkader",
  "block.minecraft.sea_lantern": "Zeelantaarn",
  "block.minecraft.sea_pickle": "Zeeaurgurk",
  "block.minecraft.seagrass": "Zeegras",
  "block.minecraft.set_spawn": "Respawnpunt ingesteld",
  "block.minecraft.short_dry_grass": "Kort droog gras",
  "block.minecraft.short_grass": "Kort gras",
  "block.minecraft.shroomlight": "Zwammenlicht",
  "block.minecraft.shulker_box": "Shulkerdoos",
  "block.minecraft.skeleton_skull": "Skelettenschedel",
  "block.minecraft.skeleton_wall_skull": "Skelettenschedel aan muur",
  "block.minecraft.slime_block": "Slijmblok",
  "block.minecraft.small_amethyst_bud": "Kleine amethistknop",
  "block.minecraft.small_dripleaf": "Klein druipblad",
  "block.minecraft.smithing_table": "Smeedtafel",
  "block.minecraft.smoker": "Roker",
  "block.minecraft.smooth_basalt": "Glad basalt",
  "block.minecraft.smooth_quartz": "Glad kwartsblok",
  "block.minecraft.smooth_quartz_slab": "Gladde kwartsplaat",
  "block.minecraft.smooth_quartz_stairs": "Gladde kwartstrap",
  "block.minecraft.smooth_red_sandstone": "Glad rood zandsteen",
  "block.minecraft.smooth_red_sandstone_slab": "Gladde rode zandstenen plaat",
  "block.minecraft.smooth_red_sandstone_stairs": "Gladde rode zandstenen trap",
  "block.minecraft.smooth_sandstone": "Glad zandsteen",
  "block.minecraft.smooth_sandstone_slab": "Gladde zandstenen plaat",
  "block.minecraft.smooth_sandstone_stairs": "Gladde zandstenen trap",
  "block.minecraft.smooth_stone": "Gladde steen",
  "block.minecraft.smooth_stone_slab": "Gladde Stenen Plaat",
  "block.minecraft.sniffer_egg": "Snuffelei",
  "block.minecraft.snow": "Sneeuw",
  "block.minecraft.snow_block": "Sneeuwblok",
  "block.minecraft.soul_campfire": "Zielenkampvuur",
  "block.minecraft.soul_fire": "Zielenvuur",
  "block.minecraft.soul_lantern": "Zielenlantaarn",
  "block.minecraft.soul_sand": "Zielenzand",
  "block.minecraft.soul_soil": "Zielenaarde",
  "block.minecraft.soul_torch": "Zielenfakkel",
  "block.minecraft.soul_wall_torch": "Zielenfakkel aan muur",
  "block.minecraft.spawn.not_valid": "U heeft geen bed, opgeladen respawnanker of ze waren geblokkeerd",
  "block.minecraft.spawner": "Monsterkooi",
  "block.minecraft.spawner.desc1": "Interactie met spawnei:",
  "block.minecraft.spawner.desc2": "Bepaalt te spawnen wezentype",
  "block.minecraft.sponge": "Spons",
  "block.minecraft.spore_blossom": "Sporebloesem",
  "block.minecraft.spruce_button": "Sparren knop",
  "block.minecraft.spruce_door": "Sparren deur",
  "block.minecraft.spruce_fence": "Sparrenhouten hek",
  "block.minecraft.spruce_fence_gate": "Sparrenhouten poort",
  "block.minecraft.spruce_hanging_sign": "Sparrenhouten hangbord",
  "block.minecraft.spruce_leaves": "Sparrenbladeren",
  "block.minecraft.spruce_log": "Sparrenstam",
  "block.minecraft.spruce_planks": "Sparren planken",
  "block.minecraft.spruce_pressure_plate": "Sparren drukplaat",
  "block.minecraft.spruce_sapling": "Sparrenkiemplant",
  "block.minecraft.spruce_shelf": "Sparrenhouten plank",
  "block.minecraft.spruce_sign": "Sparren bord",
  "block.minecraft.spruce_slab": "Sparren plaat",
  "block.minecraft.spruce_stairs": "Sparren trap",
  "block.minecraft.spruce_trapdoor": "Sparren valluik",
  "block.minecraft.spruce_wall_hanging_sign": "Sparrenhouten uithangbord",
  "block.minecraft.spruce_wall_sign": "Sparren bord aan muur",
  "block.minecraft.spruce_wood": "Sparrenhout",
  "block.minecraft.sticky_piston": "Kleefzuiger",
  "block.minecraft.stone": "Steen",
  "block.minecraft.stone_brick_slab": "Blokstenen plaat",
  "block.minecraft.stone_brick_stairs": "Blokstenen trap",
  "block.minecraft.stone_brick_wall": "Blokstenen muur",
  "block.minecraft.stone_bricks": "Blokstenen",
  "block.minecraft.stone_button": "Stenen knop",
  "block.minecraft.stone_pressure_plate": "Stenen drunkplaat",
  "block.minecraft.stone_slab": "Stenen plaat",
  "block.minecraft.stone_stairs": "Stenen trap",
  "block.minecraft.stonecutter": "Steenhouwer",
  "block.minecraft.stripped_acacia_log": "Gestripte acaciastam",
  "block.minecraft.stripped_acacia_wood": "Gestript acaciahout",
  "block.minecraft.stripped_bamboo_block": "Gestript bamboeblok",
  "block.minecraft.stripped_birch_log": "Gestripte berkenstam",
  "block.minecraft.stripped_birch_wood": "Gestript berkenhout",
  "block.minecraft.stripped_cherry_log": "Gestripte kersenboomstam",
  "block.minecraft.stripped_cherry_wood": "Gestript kersenhout",
  "block.minecraft.stripped_crimson_hyphae": "Gestripte helrode schimmeldraden",
  "block.minecraft.stripped_crimson_stem": "Gestripte helrode stam",
  "block.minecraft.stripped_dark_oak_log": "Gestripte donkereikenstam",
  "block.minecraft.stripped_dark_oak_wood": "Gestript donkereikenhout",
  "block.minecraft.stripped_jungle_log": "Gestripte oerwoudstam",
  "block.minecraft.stripped_jungle_wood": "Gestript oerwoudhout",
  "block.minecraft.stripped_mangrove_log": "Gestripte mangrovestam",
  "block.minecraft.stripped_mangrove_wood": "Gestript mangrovehout",
  "block.minecraft.stripped_oak_log": "Gestripte eikenstam",
  "block.minecraft.stripped_oak_wood": "Gestript eikenhout",
  "block.minecraft.stripped_pale_oak_log": "Gestripte Bleke Eikenstam",
  "block.minecraft.stripped_pale_oak_wood": "Gestripte Bleke Eikenhouten Schors",
  "block.minecraft.stripped_spruce_log": "Gestripte sparrenstam",
  "block.minecraft.stripped_spruce_wood": "Gestript sparrenhout",
  "block.minecraft.stripped_warped_hyphae": "Gestripte spookachtige schimmeldraden",
  "block.minecraft.stripped_warped_stem": "Gestripte spookachtige stam",
  "block.minecraft.structure_block": "Structuurblok",
  "block.minecraft.structure_void": "Structuurleegte",
  "block.minecraft.sugar_cane": "Suikerriet",
  "block.minecraft.sunflower": "Zonnebloem",
  "block.minecraft.suspicious_gravel": "Verdachte grind",
  "block.minecraft.suspicious_sand": "Verdacht zand",
  "block.minecraft.sweet_berry_bush": "Zoetbesstruik",
  "block.minecraft.tall_dry_grass": "Hoog droog gras",
  "block.minecraft.tall_grass": "Hoog gras",
  "block.minecraft.tall_seagrass": "Hoog zeegras",
  "block.minecraft.target": "Doelwit",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Testblok",
  "block.minecraft.test_instance_block": "Testinstantieblok",
  "block.minecraft.tinted_glass": "Getint glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-explosies zijn uitgeschakeld",
  "block.minecraft.torch": "Fakkel",
  "block.minecraft.torchflower": "Fakkelbloem",
  "block.minecraft.torchflower_crop": "Fakkelbloemgewas",
  "block.minecraft.trapped_chest": "Kist met valstrik",
  "block.minecraft.trial_spawner": "Beproevingsspawner",
  "block.minecraft.tripwire": "Struikeldraad",
  "block.minecraft.tripwire_hook": "Struikeldraad haak",
  "block.minecraft.tube_coral": "Buiskoraal",
  "block.minecraft.tube_coral_block": "Buiskoraalblok",
  "block.minecraft.tube_coral_fan": "Buiskoraalwaaier",
  "block.minecraft.tube_coral_wall_fan": "Buiskoraalwaaier aan muur",
  "block.minecraft.tuff": "Tufsteen",
  "block.minecraft.tuff_brick_slab": "Tufblok plaat",
  "block.minecraft.tuff_brick_stairs": "Tufblok trap",
  "block.minecraft.tuff_brick_wall": "Tufblok muur",
  "block.minecraft.tuff_bricks": "Tufblok",
  "block.minecraft.tuff_slab": "Tufstenen plaat",
  "block.minecraft.tuff_stairs": "Tufstenen trap",
  "block.minecraft.tuff_wall": "Tufstenen muur",
  "block.minecraft.turtle_egg": "Schildpadei",
  "block.minecraft.twisting_vines": "Verwikkelde klimop",
  "block.minecraft.twisting_vines_plant": "Verwikkelde klimplant",
  "block.minecraft.vault": "Kluis",
  "block.minecraft.verdant_froglight": "Groen kikkerlicht",
  "block.minecraft.vine": "Lianen",
  "block.minecraft.void_air": "Luchtledigheid",
  "block.minecraft.wall_torch": "Fakkel aan muur",
  "block.minecraft.warped_button": "Spookachtige houten knop",
  "block.minecraft.warped_door": "Spookachtige houten deur",
  "block.minecraft.warped_fence": "Spookachtig houten hek",
  "block.minecraft.warped_fence_gate": "Spookachtige houten poort",
  "block.minecraft.warped_fungus": "Spookachtige zwam",
  "block.minecraft.warped_hanging_sign": "Spookachtig houten hangbord",
  "block.minecraft.warped_hyphae": "Spookachtige schimmeldraden",
  "block.minecraft.warped_nylium": "Spookachtig nylium",
  "block.minecraft.warped_planks": "Spookachtige houten planken",
  "block.minecraft.warped_pressure_plate": "Spookachtige houten drukplaat",
  "block.minecraft.warped_roots": "Spookachtige wortels",
  "block.minecraft.warped_shelf": "Spookachtig houten plank",
  "block.minecraft.warped_sign": "Spookachtig bord",
  "block.minecraft.warped_slab": "Spookachtige houten plaat",
  "block.minecraft.warped_stairs": "Spookachtige houten trap",
  "block.minecraft.warped_stem": "Spookachtige stam",
  "block.minecraft.warped_trapdoor": "Spookachtig houten valluik",
  "block.minecraft.warped_wall_hanging_sign": "Spookachtig houten uithangbord",
  "block.minecraft.warped_wall_sign": "Spookachtig bord aan muur",
  "block.minecraft.warped_wart_block": "Spookachtig kruidblok",
  "block.minecraft.water": "Water",
  "block.minecraft.water_cauldron": "Ketel met water",
  "block.minecraft.waxed_chiseled_copper": "Ingewassen bewerkt koperblok",
  "block.minecraft.waxed_copper_bars": "Ingewassen koperen tralies",
  "block.minecraft.waxed_copper_block": "Ingewassen koperblok",
  "block.minecraft.waxed_copper_bulb": "Ingewassen koperen lamp",
  "block.minecraft.waxed_copper_chain": "Ingewassen koperen ketting",
  "block.minecraft.waxed_copper_chest": "Ingewassen koperen kist",
  "block.minecraft.waxed_copper_door": "Ingewassen koperen deur",
  "block.minecraft.waxed_copper_golem_statue": "Ingewassen kopergolemstandbeeld",
  "block.minecraft.waxed_copper_grate": "Ingewassen koperen rooster",
  "block.minecraft.waxed_copper_lantern": "Ingewassen koperen lantaarn",
  "block.minecraft.waxed_copper_trapdoor": "Ingewassen koperen valluik",
  "block.minecraft.waxed_cut_copper": "Ingewassen gesneden koperblok",
  "block.minecraft.waxed_cut_copper_slab": "Ingewassen gesneden koperen plaat",
  "block.minecraft.waxed_cut_copper_stairs": "Ingewassen gesneden koperen trap",
  "block.minecraft.waxed_exposed_chiseled_copper": "Ingewassen blootgesteld bewerkt koperblok",
  "block.minecraft.waxed_exposed_copper": "Ingewassen vrijliggend koperblok",
  "block.minecraft.waxed_exposed_copper_bars": "Ingewassen blootgestelde koperen tralies",
  "block.minecraft.waxed_exposed_copper_bulb": "Gewaxte Bloodgestelde Koperen Lamp",
  "block.minecraft.waxed_exposed_copper_chain": "Ingewassen blootgestelde koperen ketting",
  "block.minecraft.waxed_exposed_copper_chest": "Ingewassen blootgestelde koperen kist",
  "block.minecraft.waxed_exposed_copper_door": "Gewaxte bloodgestelde koper deur",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Ingewassen blootgesteld kopergolemstandbeeld",
  "block.minecraft.waxed_exposed_copper_grate": "Gewaxte bloodgestelde koper rooster",
  "block.minecraft.waxed_exposed_copper_lantern": "Ingewassen blootgestelde koperen lantaarn",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Ingewassen Blootgestelde Koperen Valluik",
  "block.minecraft.waxed_exposed_cut_copper": "Ingewassen vrijliggend gesneden koperblok",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ingewassen vrijliggende gesneden koperen plaat",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ingewassen vrijliggend gesneden koperen trap",
  "block.minecraft.waxed_exposed_lightning_rod": "Ingewassen blootgestelde bliksemafleider",
  "block.minecraft.waxed_lightning_rod": "Ingewassen bliksemafleider",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Ingewassen Geoxideerd Gebeiteld Koperblok",
  "block.minecraft.waxed_oxidized_copper": "Ingewassen geoxideerd koperblok",
  "block.minecraft.waxed_oxidized_copper_bars": "Ingewassen geoxideerde koperen tralies",
  "block.minecraft.waxed_oxidized_copper_bulb": "Ingewassen Geoxideerde Koperen Lamp",
  "block.minecraft.waxed_oxidized_copper_chain": "Ingewassen geoxideerde koperen ketting",
  "block.minecraft.waxed_oxidized_copper_chest": "Ingewassen geoxideerde koperen kist",
  "block.minecraft.waxed_oxidized_copper_door": "Ingewassen Geoxideerde Koperen Deur",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Ingewassen geoxideerd kopergolemstandbeeld",
  "block.minecraft.waxed_oxidized_copper_grate": "Ingewassen Geoxideerd Koperen Rooster",
  "block.minecraft.waxed_oxidized_copper_lantern": "Ingewassen geoxideerde koperen lantaarn",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Ingewassen Geoxideerde Koperen Valluik",
  "block.minecraft.waxed_oxidized_cut_copper": "Ingewassen geoxideerd gesneden koperblok",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Ingewassen geoxideerde gesneden koperen plaat",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Ingewassen geoxideerde gesneden koperen trap",
  "block.minecraft.waxed_oxidized_lightning_rod": "Ingewassen geoxideerde bliksemafleider",
  "block.minecraft.waxed_weathered_chiseled_copper": "Ingewassen Verweerd Gebeiteld Koperblok",
  "block.minecraft.waxed_weathered_copper": "Ingewassen verweerd koperblok",
  "block.minecraft.waxed_weathered_copper_bars": "Ingewassen verweerde koperen tralies",
  "block.minecraft.waxed_weathered_copper_bulb": "Ingewassen Verweerde Koperen Lamp",
  "block.minecraft.waxed_weathered_copper_chain": "Ingewassen verweerde koperen ketting",
  "block.minecraft.waxed_weathered_copper_chest": "Ingewassen verweerde koperen kist",
  "block.minecraft.waxed_weathered_copper_door": "Ingewassen Verweerde Koperen Deur",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Ingewassen verweerd kopergolemstandbeeld",
  "block.minecraft.waxed_weathered_copper_grate": "Ingewassen Verweerd Koperen Rooster",
  "block.minecraft.waxed_weathered_copper_lantern": "Ingewassen verweerde koperen lantaarn",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Ingewassen Verweerd Koperen Valluik",
  "block.minecraft.waxed_weathered_cut_copper": "Ingewassen verweerd gesneden koperblok",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Ingewassen verweerde gesneden koperen plaat",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Ingewassen verweerde gesneden koperen trap",
  "block.minecraft.waxed_weathered_lightning_rod": "Ingewassen verweerde bliksemafleider",
  "block.minecraft.weathered_chiseled_copper": "Verweerd Gebeiteld Koperblok",
  "block.minecraft.weathered_copper": "Verweerd koperblok",
  "block.minecraft.weathered_copper_bars": "Verweerde koperen tralies",
  "block.minecraft.weathered_copper_bulb": "Verweerde Koperen Lamp",
  "block.minecraft.weathered_copper_chain": "Verweerde koperen ketting",
  "block.minecraft.weathered_copper_chest": "Verweerde koperen kist",
  "block.minecraft.weathered_copper_door": "Verweerde Koperen Deur",
  "block.minecraft.weathered_copper_golem_statue": "Verweerd kopergolemstandbeeld",
  "block.minecraft.weathered_copper_grate": "Verweerd Koperen Rooster",
  "block.minecraft.weathered_copper_lantern": "Verweerde koperen lantaarn",
  "block.minecraft.weathered_copper_trapdoor": "Verweerd Koperen Valluik",
  "block.minecraft.weathered_cut_copper": "Geoxideerd gesneden koperblok",
  "block.minecraft.weathered_cut_copper_slab": "Verweerde gesneden koperen plaat",
  "block.minecraft.weathered_cut_copper_stairs": "Verweerde gesneden koperen trap",
  "block.minecraft.weathered_lightning_rod": "Verweerde bliksemafleider",
  "block.minecraft.weeping_vines": "Hangende klimop",
  "block.minecraft.weeping_vines_plant": "Hangende klimplant",
  "block.minecraft.wet_sponge": "Natte spons",
  "block.minecraft.wheat": "Tarwe",
  "block.minecraft.white_banner": "Witte vlag",
  "block.minecraft.white_bed": "Wit bed",
  "block.minecraft.white_candle": "Witte kaars",
  "block.minecraft.white_candle_cake": "Taart met witte kaars",
  "block.minecraft.white_carpet": "Wit tapijt",
  "block.minecraft.white_concrete": "Wit beton",
  "block.minecraft.white_concrete_powder": "Wit cement",
  "block.minecraft.white_glazed_terracotta": "Witgeglazuurde terracotte",
  "block.minecraft.white_shulker_box": "Witte Shulkerdoos",
  "block.minecraft.white_stained_glass": "Witgekleurd glas",
  "block.minecraft.white_stained_glass_pane": "Witgekleurde glazen ruit",
  "block.minecraft.white_terracotta": "Wit terracotta",
  "block.minecraft.white_tulip": "Witte tulp",
  "block.minecraft.white_wool": "Witte wol",
  "block.minecraft.wildflowers": "Wilde bloemen",
  "block.minecraft.wither_rose": "Witherroos",
  "block.minecraft.wither_skeleton_skull": "Witherskelettenschedel",
  "block.minecraft.wither_skeleton_wall_skull": "Witherskelettenschedel aan muur",
  "block.minecraft.yellow_banner": "Gele vlag",
  "block.minecraft.yellow_bed": "Geel bed",
  "block.minecraft.yellow_candle": "Gele kaars",
  "block.minecraft.yellow_candle_cake": "Taart met gele kaars",
  "block.minecraft.yellow_carpet": "Geel tapijt",
  "block.minecraft.yellow_concrete": "Geel beton",
  "block.minecraft.yellow_concrete_powder": "Geel cement",
  "block.minecraft.yellow_glazed_terracotta": "Geelgeglazuurde terracotta",
  "block.minecraft.yellow_shulker_box": "Gele Shulkerdoos",
  "block.minecraft.yellow_stained_glass": "Geelgekleurd glas",
  "block.minecraft.yellow_stained_glass_pane": "Geelgekleurde glazen ruit",
  "block.minecraft.yellow_terracotta": "Geel terracotta",
  "block.minecraft.yellow_wool": "Gele wol",
  "block.minecraft.zombie_head": "Zombiehoofd",
  "block.minecraft.zombie_wall_head": "Zombiehoofd aan muur",
  "item.minecraft.acacia_boat": "Acaciahouten boot",
  "item.minecraft.acacia_chest_boat": "Acaciahouten boot met kist",
  "item.minecraft.allay_spawn_egg": "Helperspawnei",
  "item.minecraft.amethyst_shard": "Amethistscherf",
  "item.minecraft.angler_pottery_shard": "Angler Aardewerk Scherf",
  "item.minecraft.angler_pottery_sherd": "Angler Aardewerk Scherf",
  "item.minecraft.apple": "Appel",
  "item.minecraft.archer_pottery_shard": "Boogschutter Aardewerk Scherf",
  "item.minecraft.archer_pottery_sherd": "Archer Aardewerk Scherf",
  "item.minecraft.armadillo_scute": "Gordeldierschub",
  "item.minecraft.armadillo_spawn_egg": "Gordeldierspawnei",
  "item.minecraft.armor_stand": "Harnashouder",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Aardewerk Scherf",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up aardewerkscherf",
  "item.minecraft.arrow": "Pijl",
  "item.minecraft.axolotl_bucket": "Emmer met axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotlspawnei",
  "item.minecraft.baked_potato": "Gebakken patat",
  "item.minecraft.bamboo_chest_raft": "Bamboevlot met kist",
  "item.minecraft.bamboo_raft": "Bamboevlot",
  "item.minecraft.bat_spawn_egg": "Vleermuizenspawnei",
  "item.minecraft.bee_spawn_egg": "Bijenspawnei",
  "item.minecraft.beef": "Rauwe biefstuk",
  "item.minecraft.beetroot": "Biet",
  "item.minecraft.beetroot_seeds": "Bietenzaden",
  "item.minecraft.beetroot_soup": "Bietensoep",
  "item.minecraft.birch_boat": "Berkenhouten boot",
  "item.minecraft.birch_chest_boat": "Berkenhouten boot met kist",
  "item.minecraft.black_bundle": "Zwarte Bundel",
  "item.minecraft.black_dye": "Zwarte kleurstof",
  "item.minecraft.black_harness": "Zwart tuig",
  "item.minecraft.blade_pottery_shard": "Blade aardewerk scherf",
  "item.minecraft.blade_pottery_sherd": "Mes Aardewerk Scherf",
  "item.minecraft.blaze_powder": "Blazepoeder",
  "item.minecraft.blaze_rod": "Blazestaf",
  "item.minecraft.blaze_spawn_egg": "Blazespawnei",
  "item.minecraft.blue_bundle": "Blauwe Bundel",
  "item.minecraft.blue_dye": "Blauwe kleurstof",
  "item.minecraft.blue_egg": "Blauw Ei",
  "item.minecraft.blue_harness": "Blauw tuig",
  "item.minecraft.bogged_spawn_egg": "Zomperspawnei",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bout Harnasversiering",
  "item.minecraft.bone": "Bot",
  "item.minecraft.bone_meal": "Beendermeel",
  "item.minecraft.book": "Boek",
  "item.minecraft.bordure_indented_banner_pattern": "Ingekorte Bordure Vlagpatroon",
  "item.minecraft.bow": "Boog",
  "item.minecraft.bowl": "Kom",
  "item.minecraft.bread": "Brood",
  "item.minecraft.breeze_rod": "Vlaagstaaf",
  "item.minecraft.breeze_spawn_egg": "Vlagenspawnei",
  "item.minecraft.brewer_pottery_shard": "Brouwer aardewerk scherf",
  "item.minecraft.brewer_pottery_sherd": "Brouwer aardewerk scherf",
  "item.minecraft.brewing_stand": "Brouwstandaard",
  "item.minecraft.brick": "Baksteen",
  "item.minecraft.brown_bundle": "Bruine Bundel",
  "item.minecraft.brown_dye": "Bruine kleurstof",
  "item.minecraft.brown_egg": "Bruin Ei",
  "item.minecraft.brown_harness": "Bruin tuig",
  "item.minecraft.brush": "Borstel",
  "item.minecraft.bucket": "Emmer",
  "item.minecraft.bundle": "Bundel",
  "item.minecraft.bundle.empty": "Leeg",
  "item.minecraft.bundle.empty.description": "Kan een gemengde stapel items bevatten",
  "item.minecraft.bundle.full": "Vol",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Aardewerkscherf verbranden",
  "item.minecraft.burn_pottery_sherd": "Aardewerkscherf verbranden",
  "item.minecraft.camel_husk_spawn_egg": "Dromedarismummiespawnei",
  "item.minecraft.camel_spawn_egg": "Dromedarisspawnei",
  "item.minecraft.carrot": "Wortel",
  "item.minecraft.carrot_on_a_stick": "Wortel aan een stok",
  "item.minecraft.cat_spawn_egg": "Kattenspawnei",
  "item.minecraft.cauldron": "Ketel",
  "item.minecraft.cave_spider_spawn_egg": "Grottenspinnenspawnei",
  "item.minecraft.chainmail_boots": "Maliënlaarzen",
  "item.minecraft.chainmail_chestplate": "Maliënkolder",
  "item.minecraft.chainmail_helmet": "Maliënkap",
  "item.minecraft.chainmail_leggings": "Maliënbroek",
  "item.minecraft.charcoal": "Houtskool",
  "item.minecraft.cherry_boat": "Kersenhouten boot",
  "item.minecraft.cherry_chest_boat": "Kersenhouten boot met kist",
  "item.minecraft.chest_minecart": "Mijnkar met kist",
  "item.minecraft.chicken": "Rauwe kip",
  "item.minecraft.chicken_spawn_egg": "Kippenspawnei",
  "item.minecraft.chorus_fruit": "Chorusfruit",
  "item.minecraft.clay_ball": "Kleibal",
  "item.minecraft.clock": "Klok",
  "item.minecraft.coal": "Steenkool",
  "item.minecraft.coast_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Kust Harnasversiering",
  "item.minecraft.cocoa_beans": "Cacaobonen",
  "item.minecraft.cod": "Rauwe kabeljauw",
  "item.minecraft.cod_bucket": "Emmer met kabeljauw",
  "item.minecraft.cod_spawn_egg": "Kabeljauwspawnei",
  "item.minecraft.command_block_minecart": "Mijnkar met opdrachtblok",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Biefstuk",
  "item.minecraft.cooked_chicken": "Gebraden kip",
  "item.minecraft.cooked_cod": "Gebakken kabeljauw",
  "item.minecraft.cooked_mutton": "Gebraden schapenvlees",
  "item.minecraft.cooked_porkchop": "Gebraden varkensvlees",
  "item.minecraft.cooked_rabbit": "Gebraden konijnenvlees",
  "item.minecraft.cooked_salmon": "Gebakken zalm",
  "item.minecraft.cookie": "Koekje",
  "item.minecraft.copper_axe": "Koperen bijl",
  "item.minecraft.copper_boots": "Koperen laarzen",
  "item.minecraft.copper_chestplate": "Koperen borstplaat",
  "item.minecraft.copper_golem_spawn_egg": "Kopergolemspawnei",
  "item.minecraft.copper_helmet": "Koperen helm",
  "item.minecraft.copper_hoe": "Koperen schoffel",
  "item.minecraft.copper_horse_armor": "Koperen paardenharnas",
  "item.minecraft.copper_ingot": "Koperstaaf",
  "item.minecraft.copper_leggings": "Koperen beenstukken",
  "item.minecraft.copper_nautilus_armor": "Koperen nautilusharnas",
  "item.minecraft.copper_nugget": "Koperklompje",
  "item.minecraft.copper_pickaxe": "Koperen houweel",
  "item.minecraft.copper_shovel": "Koperen schep",
  "item.minecraft.copper_spear": "Koperen speer",
  "item.minecraft.copper_sword": "Koperen zwaard",
  "item.minecraft.cow_spawn_egg": "Koeienspawnei",
  "item.minecraft.creaking_spawn_egg": "Schorswakerspawnei",
  "item.minecraft.creeper_banner_pattern": "Vlagpatroon",
  "item.minecraft.creeper_banner_pattern.desc": "Creeperwapen",
  "item.minecraft.creeper_banner_pattern.new": "Creeperwapen Vlagpatroon",
  "item.minecraft.creeper_spawn_egg": "Creeperspawnei",
  "item.minecraft.crossbow": "Kruisboog",
  "item.minecraft.crossbow.projectile": "Projectiel:",
  "item.minecraft.crossbow.projectile.multiple": "Projectiel: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectiel: %s",
  "item.minecraft.cyan_bundle": "Cyaan Bundel",
  "item.minecraft.cyan_dye": "Cyaan kleurstof",
  "item.minecraft.cyan_harness": "Turquoise tuig",
  "item.minecraft.danger_pottery_shard": "Gevaar Aardewerk Scherf",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "Donkereikenhouten boot",
  "item.minecraft.dark_oak_chest_boat": "Donkereikenhouten boot met kist",
  "item.minecraft.debug_stick": "Debugstok",
  "item.minecraft.debug_stick.empty": "%s heeft geen eigenschappen",
  "item.minecraft.debug_stick.select": "'%s' geselecteerd (%s)",
  "item.minecraft.debug_stick.update": "'%s' naar %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamanten bijl",
  "item.minecraft.diamond_boots": "Diamanten Laarzen",
  "item.minecraft.diamond_chestplate": "Diamanten borstplaat",
  "item.minecraft.diamond_helmet": "Diamanten helm",
  "item.minecraft.diamond_hoe": "Diamanten schoffel",
  "item.minecraft.diamond_horse_armor": "Diamanten paardenharnas",
  "item.minecraft.diamond_leggings": "Diamanten beenstukken",
  "item.minecraft.diamond_nautilus_armor": "Diamanten nautilusharnas",
  "item.minecraft.diamond_pickaxe": "Diamanten houweel",
  "item.minecraft.diamond_shovel": "Diamanten schup",
  "item.minecraft.diamond_spear": "Diamanten speer",
  "item.minecraft.diamond_sword": "Diamanten zwaard",
  "item.minecraft.disc_fragment_5": "Muziekplaatfragment",
  "item.minecraft.disc_fragment_5.desc": "Muziekplaat - 5",
  "item.minecraft.dolphin_spawn_egg": "Dolfijnenspawnei",
  "item.minecraft.donkey_spawn_egg": "Ezelspawnei",
  "item.minecraft.dragon_breath": "Drakenadem",
  "item.minecraft.dried_kelp": "Gedroogde kelp",
  "item.minecraft.drowned_spawn_egg": "Drenkelingspawnei",
  "item.minecraft.dune_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Duin Harnasversiering",
  "item.minecraft.echo_shard": "Echoscherf",
  "item.minecraft.egg": "Ei",
  "item.minecraft.elder_guardian_spawn_egg": "Oudebewakerspawnei",
  "item.minecraft.elytra": "Dekschild",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Betoverd boek",
  "item.minecraft.enchanted_golden_apple": "Betoverde gouden appel",
  "item.minecraft.end_crystal": "Endkristal",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdrakenspawnei",
  "item.minecraft.ender_eye": "Enderoog",
  "item.minecraft.ender_pearl": "Enderparel",
  "item.minecraft.enderman_spawn_egg": "Endermannenspawnei",
  "item.minecraft.endermite_spawn_egg": "Endermitespawnei",
  "item.minecraft.evoker_spawn_egg": "Oproeperspawnei",
  "item.minecraft.experience_bottle": "Magiërsextract",
  "item.minecraft.explorer_pottery_shard": "Ontdekkingsreiziger Aardewerkscherf",
  "item.minecraft.explorer_pottery_sherd": "Ontdekkingsreiziger Aardewerkscherf",
  "item.minecraft.eye_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Oog Harnasversiering",
  "item.minecraft.feather": "Veer",
  "item.minecraft.fermented_spider_eye": "Gefermenteerd spinnenoog",
  "item.minecraft.field_masoned_banner_pattern": "Metselwerkbanierpatroon",
  "item.minecraft.filled_map": "Kaart",
  "item.minecraft.fire_charge": "Vuurbal",
  "item.minecraft.firework_rocket": "Vuurpijl",
  "item.minecraft.firework_rocket.flight": "Vluchtduur:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Vuurwerkster",
  "item.minecraft.firework_star.black": "Zwart",
  "item.minecraft.firework_star.blue": "Blauw",
  "item.minecraft.firework_star.brown": "Bruin",
  "item.minecraft.firework_star.custom_color": "Aangepast",
  "item.minecraft.firework_star.cyan": "Cyaan",
  "item.minecraft.firework_star.fade_to": "Overgang naar",
  "item.minecraft.firework_star.flicker": "Twinkel",
  "item.minecraft.firework_star.gray": "Grijs",
  "item.minecraft.firework_star.green": "Groen",
  "item.minecraft.firework_star.light_blue": "Lichtblauw",
  "item.minecraft.firework_star.light_gray": "Lichtgrijs",
  "item.minecraft.firework_star.lime": "Limoengroen",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Oranje",
  "item.minecraft.firework_star.pink": "Roze",
  "item.minecraft.firework_star.purple": "Paars",
  "item.minecraft.firework_star.red": "Rood",
  "item.minecraft.firework_star.shape": "Onbekende vorm",
  "item.minecraft.firework_star.shape.burst": "Explosie",
  "item.minecraft.firework_star.shape.creeper": "Creepervormig",
  "item.minecraft.firework_star.shape.large_ball": "Grote bal",
  "item.minecraft.firework_star.shape.small_ball": "Kleine bal",
  "item.minecraft.firework_star.shape.star": "Stervormig",
  "item.minecraft.firework_star.trail": "Spoor",
  "item.minecraft.firework_star.white": "Wit",
  "item.minecraft.firework_star.yellow": "Geel",
  "item.minecraft.fishing_rod": "Vishengel",
  "item.minecraft.flint": "Vuursteen",
  "item.minecraft.flint_and_steel": "Vuursteen en staal",
  "item.minecraft.flow_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Windstroom Harnasversiering",
  "item.minecraft.flow_banner_pattern": "Vlagpatroon",
  "item.minecraft.flow_banner_pattern.desc": "Windstroom",
  "item.minecraft.flow_banner_pattern.new": "Windstroom Vlagpatroon",
  "item.minecraft.flow_pottery_sherd": "Aardewerkscherf 'windstroming'",
  "item.minecraft.flower_banner_pattern": "Vlagpatroon",
  "item.minecraft.flower_banner_pattern.desc": "Bloemwapen",
  "item.minecraft.flower_banner_pattern.new": "Bloemwapen Vlagpatroon",
  "item.minecraft.flower_pot": "Bloempot",
  "item.minecraft.fox_spawn_egg": "Vossenspawnei",
  "item.minecraft.friend_pottery_shard": "Vriend Aardewerkscherf",
  "item.minecraft.friend_pottery_sherd": "Vriend Aardewerkscherf",
  "item.minecraft.frog_spawn_egg": "Kikkerspawnei",
  "item.minecraft.furnace_minecart": "Mijnkar met oven",
  "item.minecraft.ghast_spawn_egg": "Ghastspawnei",
  "item.minecraft.ghast_tear": "Ghasttraan",
  "item.minecraft.glass_bottle": "Glazen fles",
  "item.minecraft.glistering_melon_slice": "Glinsterende meloenschijf",
  "item.minecraft.globe_banner_pattern": "Vlagpatroon",
  "item.minecraft.globe_banner_pattern.desc": "Aarde",
  "item.minecraft.globe_banner_pattern.new": "Globebanierpatroon",
  "item.minecraft.glow_berries": "Gloeibessen",
  "item.minecraft.glow_ink_sac": "Gloeiende inktzak",
  "item.minecraft.glow_item_frame": "Gloeiende voorwerplijst",
  "item.minecraft.glow_squid_spawn_egg": "Gloeiendeinktvissenspawnei",
  "item.minecraft.glowstone_dust": "Gloeisteenstof",
  "item.minecraft.goat_horn": "Geitenhoorn",
  "item.minecraft.goat_spawn_egg": "Geitenspawnei",
  "item.minecraft.gold_ingot": "Goudstaaf",
  "item.minecraft.gold_nugget": "Goudklompje",
  "item.minecraft.golden_apple": "Gouden appel",
  "item.minecraft.golden_axe": "Gouden bijl",
  "item.minecraft.golden_boots": "Gouden laarzen",
  "item.minecraft.golden_carrot": "Gouden wortel",
  "item.minecraft.golden_chestplate": "Gouden borstplaat",
  "item.minecraft.golden_helmet": "Gouden helm",
  "item.minecraft.golden_hoe": "Gouden schoffel",
  "item.minecraft.golden_horse_armor": "Gouden paardenharnas",
  "item.minecraft.golden_leggings": "Gouden beenstukken",
  "item.minecraft.golden_nautilus_armor": "Gouden nautilusharnas",
  "item.minecraft.golden_pickaxe": "Gouden houweel",
  "item.minecraft.golden_shovel": "Gouden schup",
  "item.minecraft.golden_spear": "Gouden speer",
  "item.minecraft.golden_sword": "Gouden zwaard",
  "item.minecraft.gray_bundle": "Grijze Bundel",
  "item.minecraft.gray_dye": "Grijze kleurstof",
  "item.minecraft.gray_harness": "Grijs tuig",
  "item.minecraft.green_bundle": "Groene Bundel",
  "item.minecraft.green_dye": "Groene kleurstof",
  "item.minecraft.green_harness": "Groen tuig",
  "item.minecraft.guardian_spawn_egg": "Bewakerspawnei",
  "item.minecraft.gunpowder": "Buskruit",
  "item.minecraft.guster_banner_pattern": "Banierpatroon",
  "item.minecraft.guster_banner_pattern.desc": "Rukwind",
  "item.minecraft.guster_banner_pattern.new": "Rukwindbanierpatroon",
  "item.minecraft.guster_pottery_sherd": "Aardewerkscherf 'rukwind'",
  "item.minecraft.happy_ghast_spawn_egg": "Vrolijkeghastspawnei",
  "item.minecraft.harness": "Tuig",
  "item.minecraft.heart_of_the_sea": "Hart van de zee",
  "item.minecraft.heart_pottery_shard": "Hart Aardewerkscherf",
  "item.minecraft.heart_pottery_sherd": "Hart Aardewerkscherf",
  "item.minecraft.heartbreak_pottery_shard": "Gebrokenhart Aardewerkscherf",
  "item.minecraft.heartbreak_pottery_sherd": "Gebrokenhard Aardewerkscherf",
  "item.minecraft.hoglin_spawn_egg": "Hoglinspawnei",
  "item.minecraft.honey_bottle": "Honingfles",
  "item.minecraft.honeycomb": "Honingraat",
  "item.minecraft.hopper_minecart": "Mijnkar met trechter",
  "item.minecraft.horse_spawn_egg": "Paardenspawnei",
  "item.minecraft.host_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Gastheer Harnasversiering",
  "item.minecraft.howl_pottery_shard": "Gehuil Aardewerkscherf",
  "item.minecraft.howl_pottery_sherd": "Gehuil Aardewerkscherf",
  "item.minecraft.husk_spawn_egg": "Mummiespawnei",
  "item.minecraft.ink_sac": "Inktzak",
  "item.minecraft.iron_axe": "Ijzeren bijl",
  "item.minecraft.iron_boots": "IJzeren laarzen",
  "item.minecraft.iron_chestplate": "IJzeren borstplaat",
  "item.minecraft.iron_golem_spawn_egg": "Ijzergolemspawnei",
  "item.minecraft.iron_helmet": "IJzeren helm",
  "item.minecraft.iron_hoe": "IJzeren schoffel",
  "item.minecraft.iron_horse_armor": "IJzeren paardenharnas",
  "item.minecraft.iron_ingot": "Ijzerstaaf",
  "item.minecraft.iron_leggings": "IJzeren beenstukken",
  "item.minecraft.iron_nautilus_armor": "IJzeren nautilusharnas",
  "item.minecraft.iron_nugget": "IJzerklompje",
  "item.minecraft.iron_pickaxe": "Ijzeren houweel",
  "item.minecraft.iron_shovel": "IJzeren schup",
  "item.minecraft.iron_spear": "IJzeren speer",
  "item.minecraft.iron_sword": "Ijzeren zwaard",
  "item.minecraft.item_frame": "Voorwerplijst",
  "item.minecraft.jungle_boat": "Oerwoudhouten boot",
  "item.minecraft.jungle_chest_boat": "Oerwoudhouten boot met kist",
  "item.minecraft.knowledge_book": "Boek der kennis",
  "item.minecraft.lapis_lazuli": "Lapis lazuli",
  "item.minecraft.lava_bucket": "Emmer lava",
  "item.minecraft.lead": "Leidtouw",
  "item.minecraft.leather": "Leer",
  "item.minecraft.leather_boots": "Leren laarzen",
  "item.minecraft.leather_chestplate": "Leren tuniek",
  "item.minecraft.leather_helmet": "Leren kap",
  "item.minecraft.leather_horse_armor": "Leren paardenharnas",
  "item.minecraft.leather_leggings": "Leren broek",
  "item.minecraft.light_blue_bundle": "Lichtblauwe Bundel",
  "item.minecraft.light_blue_dye": "Lichtblauwe kleurstof",
  "item.minecraft.light_blue_harness": "Lichtblauw tuig",
  "item.minecraft.light_gray_bundle": "Lichtgrijze Bundel",
  "item.minecraft.light_gray_dye": "Lichtgrijze kleurstof",
  "item.minecraft.light_gray_harness": "Lichtgrijs tuig",
  "item.minecraft.lime_bundle": "Lichtgroene Bundel",
  "item.minecraft.lime_dye": "Limoengroene kleurstof",
  "item.minecraft.lime_harness": "Lichtgroen tuig",
  "item.minecraft.lingering_potion": "Aanhoudende drank",
  "item.minecraft.lingering_potion.effect.awkward": "Aanhoudende vreemde drank",
  "item.minecraft.lingering_potion.effect.empty": "Aanhoudende onmaakbare drank",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Aanhoudende drank der vuurbestendigheid",
  "item.minecraft.lingering_potion.effect.harming": "Aanhoudende drank der verwonding",
  "item.minecraft.lingering_potion.effect.healing": "Aanhoudende drank der genezing",
  "item.minecraft.lingering_potion.effect.infested": "Aanhoudende drank der infestatie",
  "item.minecraft.lingering_potion.effect.invisibility": "Aanhoudende drank der onzichtbaarheid",
  "item.minecraft.lingering_potion.effect.leaping": "Aanhoudende drank der sprongen",
  "item.minecraft.lingering_potion.effect.levitation": "Aanhoudende drank der zweving",
  "item.minecraft.lingering_potion.effect.luck": "Aanhoudende drank des geluks",
  "item.minecraft.lingering_potion.effect.mundane": "Aanhoudende triviale drank",
  "item.minecraft.lingering_potion.effect.night_vision": "Aanhoudende drank des nachtzichts",
  "item.minecraft.lingering_potion.effect.oozing": "Aanhoudende drank der slijmerigheid",
  "item.minecraft.lingering_potion.effect.poison": "Aanhoudende drank des gifs",
  "item.minecraft.lingering_potion.effect.regeneration": "Aanhoudende drank der regeneratie",
  "item.minecraft.lingering_potion.effect.slow_falling": "Aanhoudende drank der valvertraging",
  "item.minecraft.lingering_potion.effect.slowness": "Aanhoudende drank der traagheid",
  "item.minecraft.lingering_potion.effect.strength": "Aanhoudende drank der kracht",
  "item.minecraft.lingering_potion.effect.swiftness": "Aanhoudende drank der vlotheid",
  "item.minecraft.lingering_potion.effect.thick": "Aanhoudende stroperige drank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Aanhoudende drank der schildpadmeester",
  "item.minecraft.lingering_potion.effect.water": "Aanhoudende waterfles",
  "item.minecraft.lingering_potion.effect.water_breathing": "Aanhoudende drank des wateradems",
  "item.minecraft.lingering_potion.effect.weakness": "Aanhoudende drank der zwakheid",
  "item.minecraft.lingering_potion.effect.weaving": "Aanhoudende drank der weven",
  "item.minecraft.lingering_potion.effect.wind_charged": "Aanhoudende drank des jagende winds",
  "item.minecraft.llama_spawn_egg": "Lamaspawnei",
  "item.minecraft.lodestone_compass": "Kompas wijzend naar zeilsteen",
  "item.minecraft.mace": "Knots",
  "item.minecraft.magenta_bundle": "Magenta Bundel",
  "item.minecraft.magenta_dye": "Magenta kleurstof",
  "item.minecraft.magenta_harness": "Magenta tuig",
  "item.minecraft.magma_cream": "Magmacrème",
  "item.minecraft.magma_cube_spawn_egg": "Magmakubusspawnei",
  "item.minecraft.mangrove_boat": "Mangrovehouten boot",
  "item.minecraft.mangrove_chest_boat": "Mangrovehouten boot met kist",
  "item.minecraft.map": "Lege kaart",
  "item.minecraft.melon_seeds": "Meloenzaden",
  "item.minecraft.melon_slice": "Meloenschijf",
  "item.minecraft.milk_bucket": "Emmer melk",
  "item.minecraft.minecart": "Mijnkar",
  "item.minecraft.miner_pottery_shard": "Mijnwerker Aardewerkscherf",
  "item.minecraft.miner_pottery_sherd": "Mijnwerker Aardewerkscherf",
  "item.minecraft.mojang_banner_pattern": "Vlagpatroon",
  "item.minecraft.mojang_banner_pattern.desc": "Mojangwapen",
  "item.minecraft.mojang_banner_pattern.new": "Mojanglogobanierpatroon",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroomspawnei",
  "item.minecraft.mourner_pottery_shard": "Aardewerkscherf 'rouw'",
  "item.minecraft.mourner_pottery_sherd": "Aardewerkscherf 'rouw'",
  "item.minecraft.mule_spawn_egg": "Muilezelspawnei",
  "item.minecraft.mushroom_stew": "Paddenstoelenstoofpot",
  "item.minecraft.music_disc_11": "Muziekplaat",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Muziekplaat",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muziekplaat",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muziekplaat",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muziekplaat",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muziekplaat",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Muziekplaat",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Muziekplaat",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Muziekplaat",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Muziekplaat",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muziekplaat",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muziekplaat",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muziekplaat",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Muziekplaat",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Muziekplaat",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Muziek schijf",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Muziekplaat",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muziekplaat",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Muziekplaat",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muziekplaat",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muziekplaat",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rauw schapenvlees",
  "item.minecraft.name_tag": "Naamkaartje",
  "item.minecraft.nautilus_shell": "Nautilusschelp",
  "item.minecraft.nautilus_spawn_egg": "Nautilusspawnei",
  "item.minecraft.nether_brick": "Netherbakstenen",
  "item.minecraft.nether_star": "Netherster",
  "item.minecraft.nether_wart": "Netherkruid",
  "item.minecraft.netherite_axe": "Netherieten bijl",
  "item.minecraft.netherite_boots": "Netherieten laarzen",
  "item.minecraft.netherite_chestplate": "Netherieten borstplaat",
  "item.minecraft.netherite_helmet": "Netherieten helm",
  "item.minecraft.netherite_hoe": "Netherieten schoffel",
  "item.minecraft.netherite_horse_armor": "Netherieten paardenharnas",
  "item.minecraft.netherite_ingot": "Netherietstaaf",
  "item.minecraft.netherite_leggings": "Netherieten beenstukken",
  "item.minecraft.netherite_nautilus_armor": "Netherieten nautilusharnas",
  "item.minecraft.netherite_pickaxe": "Netherieten houweel",
  "item.minecraft.netherite_scrap": "Netherietschroot",
  "item.minecraft.netherite_shovel": "Netherieten schep",
  "item.minecraft.netherite_spear": "Netherieten speer",
  "item.minecraft.netherite_sword": "Netherieten zwaard",
  "item.minecraft.netherite_upgrade_smithing_template": "Smeedssjabloon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherietupgrade",
  "item.minecraft.oak_boat": "Eikenhouten boot",
  "item.minecraft.oak_chest_boat": "Eikenhouten boot met kist",
  "item.minecraft.ocelot_spawn_egg": "Ocelottenspawnei",
  "item.minecraft.ominous_bottle": "Onheilspellende fles",
  "item.minecraft.ominous_trial_key": "Onheilspellende beproevingssleutel",
  "item.minecraft.orange_bundle": "Oranje Bundel",
  "item.minecraft.orange_dye": "Oranje kleurstof",
  "item.minecraft.orange_harness": "Oranje tuig",
  "item.minecraft.painting": "Schilderij",
  "item.minecraft.pale_oak_boat": "Bleke Eikenhouten Boot",
  "item.minecraft.pale_oak_chest_boat": "Bleke Eikenhouten Boot met Kist",
  "item.minecraft.panda_spawn_egg": "Pandaspawnei",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Zorenspawnei",
  "item.minecraft.parrot_spawn_egg": "Papegaaienspawnei",
  "item.minecraft.phantom_membrane": "Fantoommembraan",
  "item.minecraft.phantom_spawn_egg": "Fantomenspawnei",
  "item.minecraft.pig_spawn_egg": "Varkenspawnei",
  "item.minecraft.piglin_banner_pattern": "Vlagpatroon",
  "item.minecraft.piglin_banner_pattern.desc": "Snuit",
  "item.minecraft.piglin_banner_pattern.new": "Snoetbanierpatroon",
  "item.minecraft.piglin_brute_spawn_egg": "Piglinbruutspawnei",
  "item.minecraft.piglin_spawn_egg": "Piglinspawnei",
  "item.minecraft.pillager_spawn_egg": "Plunderaarspawnei",
  "item.minecraft.pink_bundle": "Roze Bundel",
  "item.minecraft.pink_dye": "Roze kleurstof",
  "item.minecraft.pink_harness": "Roze tuig",
  "item.minecraft.pitcher_plant": "Bekerplant",
  "item.minecraft.pitcher_pod": "Bekerplantbeker",
  "item.minecraft.plenty_pottery_shard": "Aardewerkscherf 'overvloed'",
  "item.minecraft.plenty_pottery_sherd": "Aardewerkscherf 'overvloed'",
  "item.minecraft.poisonous_potato": "Giftige patat",
  "item.minecraft.polar_bear_spawn_egg": "IJsberenspawnei",
  "item.minecraft.popped_chorus_fruit": "Gepoft Chorusfruit",
  "item.minecraft.porkchop": "Rauw varkensvlees",
  "item.minecraft.potato": "Patat",
  "item.minecraft.potion": "Drank",
  "item.minecraft.potion.effect.awkward": "Vreemde drank",
  "item.minecraft.potion.effect.empty": "Onmaakbare drank",
  "item.minecraft.potion.effect.fire_resistance": "Drank der vuurbestendigheid",
  "item.minecraft.potion.effect.harming": "Drank der verwonding",
  "item.minecraft.potion.effect.healing": "Drank der genezing",
  "item.minecraft.potion.effect.infested": "Drank der infestatie",
  "item.minecraft.potion.effect.invisibility": "Drank der onzichtbaarheid",
  "item.minecraft.potion.effect.leaping": "Drank der sprongen",
  "item.minecraft.potion.effect.levitation": "Drank der zweving",
  "item.minecraft.potion.effect.luck": "Drank des geluks",
  "item.minecraft.potion.effect.mundane": "Triviale drank",
  "item.minecraft.potion.effect.night_vision": "Drank des nachtzichts",
  "item.minecraft.potion.effect.oozing": "Drank der slijmerigheid",
  "item.minecraft.potion.effect.poison": "Drank des gifs",
  "item.minecraft.potion.effect.regeneration": "Drank der regeneratie",
  "item.minecraft.potion.effect.slow_falling": "Drank der valvertraging",
  "item.minecraft.potion.effect.slowness": "Drank der traagheid",
  "item.minecraft.potion.effect.strength": "Drank der kracht",
  "item.minecraft.potion.effect.swiftness": "Drank der vlotheid",
  "item.minecraft.potion.effect.thick": "Stroperige drank",
  "item.minecraft.potion.effect.turtle_master": "Drank der schildpadmeester",
  "item.minecraft.potion.effect.water": "Waterfles",
  "item.minecraft.potion.effect.water_breathing": "Drank des wateradems",
  "item.minecraft.potion.effect.weakness": "Drank der zwakheid",
  "item.minecraft.potion.effect.weaving": "Drank der weven",
  "item.minecraft.potion.effect.wind_charged": "Drank des jagende winds",
  "item.minecraft.pottery_shard_archer": "Aardewerkscherf 'boogschutter'",
  "item.minecraft.pottery_shard_arms_up": "Aardewerkscherf 'geheven armen'",
  "item.minecraft.pottery_shard_prize": "Aardewerkscherf 'beloning'",
  "item.minecraft.pottery_shard_skull": "Aardewerkscherf 'schedel'",
  "item.minecraft.powder_snow_bucket": "Emmer poedersneeuw",
  "item.minecraft.prismarine_crystals": "Prismarienkristallen",
  "item.minecraft.prismarine_shard": "Prismarienscherf",
  "item.minecraft.prize_pottery_shard": "Aardewerkscherf 'prijs'",
  "item.minecraft.prize_pottery_sherd": "Aardewerkscherf 'prijs'",
  "item.minecraft.pufferfish": "Kogelvis",
  "item.minecraft.pufferfish_bucket": "Emmer met kogelvis",
  "item.minecraft.pufferfish_spawn_egg": "Kogelvissenspawnei",
  "item.minecraft.pumpkin_pie": "Pompoentaart",
  "item.minecraft.pumpkin_seeds": "Pompoenpitten",
  "item.minecraft.purple_bundle": "Paarse Bundel",
  "item.minecraft.purple_dye": "Paarse kleurstof",
  "item.minecraft.purple_harness": "Paars tuig",
  "item.minecraft.quartz": "Netherkwarts",
  "item.minecraft.rabbit": "Rauw konijnenvlees",
  "item.minecraft.rabbit_foot": "Konijnenpootje",
  "item.minecraft.rabbit_hide": "Konijnenhuid",
  "item.minecraft.rabbit_spawn_egg": "Konijnenspawnei",
  "item.minecraft.rabbit_stew": "Konijnenstoofpot",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Heffer Harnasversiering",
  "item.minecraft.ravager_spawn_egg": "Vernielerspawnei",
  "item.minecraft.raw_copper": "Ruw koper",
  "item.minecraft.raw_gold": "Ruw goud",
  "item.minecraft.raw_iron": "Ruw ijzer",
  "item.minecraft.recovery_compass": "Herstelkompas",
  "item.minecraft.red_bundle": "Rode Bundel",
  "item.minecraft.red_dye": "Rode kleurstof",
  "item.minecraft.red_harness": "Rood tuig",
  "item.minecraft.redstone": "Redstonestof",
  "item.minecraft.resin_brick": "Harsbaksteen",
  "item.minecraft.resin_clump": "Harsdruppel",
  "item.minecraft.rib_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Harnasversiering",
  "item.minecraft.rotten_flesh": "Bedorven vlees",
  "item.minecraft.saddle": "Zadel",
  "item.minecraft.salmon": "Rauwe zalm",
  "item.minecraft.salmon_bucket": "Emmer met zalm",
  "item.minecraft.salmon_spawn_egg": "Zalmspawnei",
  "item.minecraft.scrape_pottery_sherd": "Aardewerkscherf 'schrapen'",
  "item.minecraft.scute": "Schub",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Wachtpost Harnasversiering",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Vormer Harnasversiering",
  "item.minecraft.sheaf_pottery_shard": "Aardewerkscherf 'schoof'",
  "item.minecraft.sheaf_pottery_sherd": "Aardewerkscherf 'schoof'",
  "item.minecraft.shears": "Schaar",
  "item.minecraft.sheep_spawn_egg": "Schapenspawnei",
  "item.minecraft.shelter_pottery_shard": "Aardewerkscherf 'schuilplaats'",
  "item.minecraft.shelter_pottery_sherd": "Aardewerkscherf 'schuilplaats'",
  "item.minecraft.shield": "Schild",
  "item.minecraft.shield.black": "Zwart schild",
  "item.minecraft.shield.blue": "Blauw schild",
  "item.minecraft.shield.brown": "Bruin schild",
  "item.minecraft.shield.cyan": "Cyaan schild",
  "item.minecraft.shield.gray": "Grijs schild",
  "item.minecraft.shield.green": "Groen schild",
  "item.minecraft.shield.light_blue": "Lichtblauw schild",
  "item.minecraft.shield.light_gray": "Lichtgrijs schild",
  "item.minecraft.shield.lime": "Limoengroen schild",
  "item.minecraft.shield.magenta": "Magenta schild",
  "item.minecraft.shield.orange": "Oranje schild",
  "item.minecraft.shield.pink": "Roze schild",
  "item.minecraft.shield.purple": "Paars schild",
  "item.minecraft.shield.red": "Rood schild",
  "item.minecraft.shield.white": "Wit schild",
  "item.minecraft.shield.yellow": "Geel schild",
  "item.minecraft.shulker_shell": "Shulkerschelp",
  "item.minecraft.shulker_spawn_egg": "Shulkerspawnei",
  "item.minecraft.sign": "Bord",
  "item.minecraft.silence_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stilte Harnasversiering",
  "item.minecraft.silverfish_spawn_egg": "Zilvervissenspawnei",
  "item.minecraft.skeleton_horse_spawn_egg": "Skeletpaardenspawnei",
  "item.minecraft.skeleton_spawn_egg": "Skelettenspawnei",
  "item.minecraft.skull_banner_pattern": "Vlagpatroon",
  "item.minecraft.skull_banner_pattern.desc": "Schedelwapen",
  "item.minecraft.skull_banner_pattern.new": "Schedelwapenbanierpatroon",
  "item.minecraft.skull_pottery_shard": "Aardewerkscherf 'schedel'",
  "item.minecraft.skull_pottery_sherd": "Aardewerkscherf 'schedel'",
  "item.minecraft.slime_ball": "Slijmbal",
  "item.minecraft.slime_spawn_egg": "Slijmkubusspawnei",
  "item.minecraft.smithing_template": "Smeedssjabloon",
  "item.minecraft.smithing_template.applies_to": "Van toepassing op:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Staaf of kristal toevoegen",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Wapenrusting",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Harnasstuk toevoegen",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Staven & Kristallen",
  "item.minecraft.smithing_template.ingredients": "Ingrediënten:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netherietstaaf toevoegen",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamanten Uitrusting",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Diamanten harnas, wapen of gereedschap toevoegen",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheriet Staaf",
  "item.minecraft.smithing_template.upgrade": "Upgrade: ",
  "item.minecraft.sniffer_spawn_egg": "Snuffelaarspawnei",
  "item.minecraft.snort_pottery_shard": "Aardewerkscherf 'snuffelen'",
  "item.minecraft.snort_pottery_sherd": "Aardewerkscherf 'snuffelen'",
  "item.minecraft.snout_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snoet Harnasversiering",
  "item.minecraft.snow_golem_spawn_egg": "Sneeuwgolem Spawnei",
  "item.minecraft.snowball": "Sneeuwbal",
  "item.minecraft.spectral_arrow": "Spectrale pijl",
  "item.minecraft.spider_eye": "Spinnenoog",
  "item.minecraft.spider_spawn_egg": "Spinnenspawnei",
  "item.minecraft.spire_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spits Harnasversiering",
  "item.minecraft.splash_potion": "Spattende drank",
  "item.minecraft.splash_potion.effect.awkward": "Spattende vreemde drank",
  "item.minecraft.splash_potion.effect.empty": "Spattende onmaakbare drank",
  "item.minecraft.splash_potion.effect.fire_resistance": "Spattende drank der vuurbestendigheid",
  "item.minecraft.splash_potion.effect.harming": "Spattende drank der verwonding",
  "item.minecraft.splash_potion.effect.healing": "Spattende drank der genezing",
  "item.minecraft.splash_potion.effect.infested": "Spattende drank der infestatie",
  "item.minecraft.splash_potion.effect.invisibility": "Spattende drank der onzichtbaarheid",
  "item.minecraft.splash_potion.effect.leaping": "Spattende drank der sprongen",
  "item.minecraft.splash_potion.effect.levitation": "Spattende drank der zweving",
  "item.minecraft.splash_potion.effect.luck": "Spattende drank des geluks",
  "item.minecraft.splash_potion.effect.mundane": "Spattende triviale drank",
  "item.minecraft.splash_potion.effect.night_vision": "Spattende drank des nachtzichts",
  "item.minecraft.splash_potion.effect.oozing": "Spattende drank der slijmerigheid",
  "item.minecraft.splash_potion.effect.poison": "Spattende drank des gifs",
  "item.minecraft.splash_potion.effect.regeneration": "Spattende drank der regeneratie",
  "item.minecraft.splash_potion.effect.slow_falling": "Spattende drank der valvertraging",
  "item.minecraft.splash_potion.effect.slowness": "Spattende drank der traagheid",
  "item.minecraft.splash_potion.effect.strength": "Spattende drank der kracht",
  "item.minecraft.splash_potion.effect.swiftness": "Spattende drank der vlotheid",
  "item.minecraft.splash_potion.effect.thick": "Spattende stroperige drank",
  "item.minecraft.splash_potion.effect.turtle_master": "Spattende drank der schildpadmeester",
  "item.minecraft.splash_potion.effect.water": "Spattende waterfles",
  "item.minecraft.splash_potion.effect.water_breathing": "Spattende drank des wateradems",
  "item.minecraft.splash_potion.effect.weakness": "Spattende drank der zwakheid",
  "item.minecraft.splash_potion.effect.weaving": "Spattende drank der weven",
  "item.minecraft.splash_potion.effect.wind_charged": "Spattende drank der windvlagen",
  "item.minecraft.spruce_boat": "Sparrenhouten boot",
  "item.minecraft.spruce_chest_boat": "Sparrenhouten boot met kist",
  "item.minecraft.spyglass": "Verrekijker",
  "item.minecraft.squid_spawn_egg": "Inktvissenspawnei",
  "item.minecraft.stick": "Stok",
  "item.minecraft.stone_axe": "Stenen bijl",
  "item.minecraft.stone_hoe": "Stenen schoffel",
  "item.minecraft.stone_pickaxe": "Stenen houweel",
  "item.minecraft.stone_shovel": "Stenen schup",
  "item.minecraft.stone_spear": "Stenen speer",
  "item.minecraft.stone_sword": "Stenen zwaard",
  "item.minecraft.stray_spawn_egg": "Verdwaaldenspawnei",
  "item.minecraft.strider_spawn_egg": "Lavarijderspawnei",
  "item.minecraft.string": "Draad",
  "item.minecraft.sugar": "Suiker",
  "item.minecraft.suspicious_stew": "Verdachte Stoofpot",
  "item.minecraft.sweet_berries": "Zoete bessen",
  "item.minecraft.tadpole_bucket": "Emmer kikkervis",
  "item.minecraft.tadpole_spawn_egg": "Kikkervisspawnei",
  "item.minecraft.tide_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Getijden Harnasversiering",
  "item.minecraft.tipped_arrow": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.awkward": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.empty": "Onmaakbare getipte pijl",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pijl der vuurbestendigheid",
  "item.minecraft.tipped_arrow.effect.harming": "Pijl der verwonding",
  "item.minecraft.tipped_arrow.effect.healing": "Pijl der genezing",
  "item.minecraft.tipped_arrow.effect.infested": "Pijl van Besmetting",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pijl der onzichtbaarheid",
  "item.minecraft.tipped_arrow.effect.leaping": "Pijl der sprongen",
  "item.minecraft.tipped_arrow.effect.levitation": "Pijl der zweving",
  "item.minecraft.tipped_arrow.effect.luck": "Pijl des geluks",
  "item.minecraft.tipped_arrow.effect.mundane": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pijl des nachtzichts",
  "item.minecraft.tipped_arrow.effect.oozing": "Pijl van Slijmerigheid",
  "item.minecraft.tipped_arrow.effect.poison": "Pijl des gifs",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pijl der regeneratie",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pijl der valvertraging",
  "item.minecraft.tipped_arrow.effect.slowness": "Pijl der traagheid",
  "item.minecraft.tipped_arrow.effect.strength": "Pijl der kracht",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pijl der vlotheid",
  "item.minecraft.tipped_arrow.effect.thick": "Getipte pijl",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pijl der schildpadmeester",
  "item.minecraft.tipped_arrow.effect.water": "Pijl der plonsing",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pijl des wateradems",
  "item.minecraft.tipped_arrow.effect.weakness": "Pijl der zwakheid",
  "item.minecraft.tipped_arrow.effect.weaving": "Pijl van Weven",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pijl van Windvlagen",
  "item.minecraft.tnt_minecart": "Mijnkar met TNT",
  "item.minecraft.torchflower_seeds": "Fakkelbloem zaden",
  "item.minecraft.totem_of_undying": "Totem der onsterfelijkheid",
  "item.minecraft.trader_llama_spawn_egg": "Handelaarslamaspawnei",
  "item.minecraft.trial_key": "Beproevingssleutel",
  "item.minecraft.trident": "Drietand",
  "item.minecraft.tropical_fish": "Tropische vis",
  "item.minecraft.tropical_fish_bucket": "Emmer met tropische vis",
  "item.minecraft.tropical_fish_spawn_egg": "Tropischevissenspawnei",
  "item.minecraft.turtle_helmet": "Schildpadschild",
  "item.minecraft.turtle_scute": "Zeeschildpadschub",
  "item.minecraft.turtle_spawn_egg": "Schildpaddenspawnei",
  "item.minecraft.vex_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ergernis Harnasversiering",
  "item.minecraft.vex_spawn_egg": "Ergernissenspawnei",
  "item.minecraft.villager_spawn_egg": "Dorpelingenspawnei",
  "item.minecraft.vindicator_spawn_egg": "Verdedigerspawnei",
  "item.minecraft.wandering_trader_spawn_egg": "Zwervende handelaarspawnei",
  "item.minecraft.ward_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Wacht Harnasversiering",
  "item.minecraft.warden_spawn_egg": "Hoederspawnei",
  "item.minecraft.warped_fungus_on_a_stick": "Spookachtige zwam aan een stok",
  "item.minecraft.water_bucket": "Emmer water",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Padvinder Harnasversiering",
  "item.minecraft.wheat": "Tarwe",
  "item.minecraft.wheat_seeds": "Tarwezaden",
  "item.minecraft.white_bundle": "Witte Bundel",
  "item.minecraft.white_dye": "Witte kleurstof",
  "item.minecraft.white_harness": "Wit tuig",
  "item.minecraft.wild_armor_trim_smithing_template": "Smeedssjabloon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wilde Harnasversiering",
  "item.minecraft.wind_charge": "Windvlaag",
  "item.minecraft.witch_spawn_egg": "Heksenspawnei",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherskelettenspawnei",
  "item.minecraft.wither_spawn_egg": "Wither Spawnei",
  "item.minecraft.wolf_armor": "Wolfharnas",
  "item.minecraft.wolf_spawn_egg": "Wolvenspawnei",
  "item.minecraft.wooden_axe": "Houten bijl",
  "item.minecraft.wooden_hoe": "Houten schoffel",
  "item.minecraft.wooden_pickaxe": "Houten houweel",
  "item.minecraft.wooden_shovel": "Houten schup",
  "item.minecraft.wooden_spear": "Houten speer",
  "item.minecraft.wooden_sword": "Houten zwaard",
  "item.minecraft.writable_book": "Boek en veer",
  "item.minecraft.written_book": "Geschreven boek",
  "item.minecraft.yellow_bundle": "Gele Bundel",
  "item.minecraft.yellow_dye": "Gele kleurstof",
  "item.minecraft.yellow_harness": "Geel tuig",
  "item.minecraft.zoglin_spawn_egg": "Zoglinspawnei",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiepaardenspawnei",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombienautilusspawnei",
  "item.minecraft.zombie_spawn_egg": "Zombiespawnei",
  "item.minecraft.zombie_villager_spawn_egg": "Zombiedorpelingenspawnei",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombiepiglinspawnei"
}
export const nl_be = items; 
